<template>
  <div class="pt-0" style="padding-left: 2%; padding-right: 2%; background-color: #F8F9FA;">
    <v-row class="mb-2">
      <v-col cols="12" lg="7" md="7" sm="12">
        <img
        width="10"
        height="14"
        src="@/assets/icons/back.png"
        class="mt-5 ml-0"
        style="cursor: pointer;"
        @click="goBack()"/>
        <span class="header-title ml-0">
          ข้อมูลลงทะเบียนธุรกิจ
        </span>
        <!-- FEF5E9 -->
        <v-chip
            v-if="getStatus !== ''"
            :color="getStatus == 'approved' || getStatus == 'acknowledge' ? '#ECF8EA' : getStatus == 'reject' || getStatus == 'denied' ? '#FBE5E4' : getStatus == 'pending' ? '#FEF5E9' : getStatus == 'cancel' ? '#F5F5F5':'#ECF9FF'"
            :text-color="getStatus == 'approved' || getStatus == 'acknowledge' ? '#58A144' : getStatus == 'reject' || getStatus == 'denied' ? '#D1392B' : getStatus == 'pending' ? '#E9A016' : getStatus == 'cancel' ? '#757575':'#ECF9FF'"
          >
            <span>{{ getStatus == 'approved' || getStatus == 'acknowledge' ? 'อนุมัติ' : getStatus == 'reject' || getStatus == 'denied' ? 'ไม่อนุมัติ' : getStatus == 'pending' ? 'รออนุมัติ' : getStatus == 'cancel' ? 'ยกเลิก':'-'}}</span>
          </v-chip>
      </v-col>
      <!-- approveRole -->
      <v-col cols="12" lg="5" md="5" sm="12" class="pt-0 pb-0 d-flex align-center justify-end mt-4 action-top-btn">
        <p
          v-show="itemVersion.length > 1 && getStatus === 'approve'"
          class="txt-font px-3 pt-2"
          style="margin-top: 0%;"
        >
          เวอร์ชั่น:
        </p>
        <v-select
          v-show="itemVersion.length > 1 && getStatus === 'approve'"
          v-model="versionDate"
          :items="itemVersion"
          item-text="detail"
          item-value="_id"
          class="mr-3 mt-3 elevation-0"
          background-color="#ffffff"
          @change="chageVersion(versionDate)"
          dense
          outlined
        >
        </v-select>
        <v-btn v-show="getStatus === 'pending'" width="18%" class="button-color-outline ma-0" outlined @click="dialogApproverCompany = true, approveType = 'ไม่อนุมัติ'">ไม่อนุมัติ</v-btn>
        <v-btn v-show="getStatus === 'pending'" width="18%" class="button-color ma-2 mr-5" dark @click="dialogApproverCompany = true, approveType = 'อนุมัติ'">อนุมัติ</v-btn>
        <!-- <v-btn v-show="getStatus === 'approved' && approveRole === 'Super Admin'" width="12%" class="ma-2 mr-5" outlined color="#2BA197" dark @click="copyData()">คัดลอก</v-btn> -->
        <!-- <v-btn v-show="getStatus === 'pending' && approveRole === 'User'" width="12%" class="ma-2 mr-0" outlined color="#2BA197" dark @click="copyData()">คัดลอก</v-btn> -->
        <!-- <v-btn v-show="getStatus === 'pending'" width="18%" class="button-color ma-2 mr-5" dark @click="dialogApproverCompany = true, approveType = 'ยกเลิก'">ยกเลิกเอกสาร</v-btn> -->
        <!-- <v-btn v-show="getStatus === 'reject'" width="12%" class="ma-2 mr-5" outlined color="#3776E9" dark @click="copyData()">ความเห็น</v-btn> -->
        <div class="text-center ml-3" v-if="getStatus === 'denied'">
          <v-menu
          v-model="commentcard"
          :close-on-content-click="false"
          :nudge-width="300"
          :nudge-top='-2'
          max-width="200"
          left
          offset-y
          origin='left'
          tile
          >
            <template v-slot:activator="{ on: menu, attrs }">
              <!-- <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }"> -->
                  <div>
                    <v-btn
                      color="#2BA197"
                      class="ma-2 mr-4"
                      outlined
                      dark
                      v-bind="attrs"
                      v-on="menu"
                    >
                    <v-icon left size="14px">
                      mdi-comment-text-outline
                    </v-icon>
                      <span>ความคิดเห็น</span>
                    </v-btn>
                </div>
                <!-- </template>
                <span>ความเห็น</span>
              </v-tooltip> -->
            </template>
            <v-card height="120px" width="233px" style="border-radius: 8px; border: 1px solid #EEEEEE;" elevation="0">
              <div class="py-2" style="background-color: #2BA197; height: auto; width: auto;">
                <span class="txt-head ml-3 mr-5" style="font-weight: bold; color: white; font-size: 14px;">รายละเอียดความเห็น</span>
                <v-btn
                  rounded
                  dark
                  small
                  class="ml-2"
                  icon
                  @click="commentcard = false"
                >
                <v-icon color="#ffffff" class="ml-auto" small>mdi-close</v-icon>
                </v-btn>
              </div>
              <div class="pa-3" style="background-color: white;">
                <span class="txt-font-value" style="color: black; font-size: 14px;  font-weight: 400">{{dataComment}}</span>
              </div>
              <!-- <span class="mx-3 mt-6">{{commentUpdate}}</span> -->
            </v-card>
            <!-- <v-list>
              <v-list-item
                v-for="(item, index) in items"
                :key="index"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list> -->
          </v-menu>
        </div>
        <!-- ปิดก่อน 27/03/66 -->
        <!-- <v-divider v-show="getStatus === 'denied'" vertical class="mt-2 mr-2" style="height: 40px;"></v-divider> -->
        <!-- <v-btn v-show="getStatus === 'approved' || getStatus === 'denied' || getStatus === 'cancel'" width="12%" class="button-color-outline ma-2 mr-5" outlined disabled @click="copyData()" >คัดลอก</v-btn> -->
        <!-- สิ้นสุด -->
        <!-- ปุ่มทดลอง alert snack bar -->
        <!-- <v-btn v-show="getStatus === 'approve' || getStatus === 'reject' || getStatus === 'cancel'" width="12%" class="ma-2 mr-5" outlined color="#2BA197" dark  @click="updateStatusApprove()">Test</v-btn> -->
      </v-col>
    </v-row>
    <!-- ################################# Form ข้อมูลลงทะเบียนธุรกิจ  ##################################-->
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <div>
      <v-expansion-panels
        accordion
        v-model="panel"
        multiple
      >
      <v-row dense>
        <!--################################# ข้อมูลธุรกิจองค์กร #################################-->
        <v-col cols="12">
          <v-card class="pt-5 pr-3 pl-3" elevation="0" style="border-radius: 24px;">
            <v-card-title
                  class="ra-head-text-bold mb-4"
                  style="font-size: 16px; padding-left:24px;color: #171F46;">
                  ข้อมูลธุรกิจองค์กร
                  <!-- level ยังไม่ได้กำหนด key -->
                  <v-chip class="mx-2" style= "background-color: #EFF4FD;" >
                  <span v-if="databussinessLevel === '' || getStatus === 'denied' || getStatus === 'pending' || getStatus === 'approved' || getStatus === 'cancel'" style="font-size: 14px; color: #3776E9; font-weight: 400;"
                  >Level 0</span>
                  <span v-else style="font-size: 14px; color: #3776E9; font-weight: 400;"
                  >Level {{databussinessLevel}}</span>
                </v-chip>
                </v-card-title>
                <v-card-subtitle>
                  <v-row class="">
                    <v-col cols="12" class="pl-5">
                        <p class="txt-head" style="margin-top: 0%; color: #333333;">
                        รูปแบบการลงทะเบียนธุรกิจ
                      </p>
                      <p class="txt-font-value" style="margin-top: 0%; color: #333333; font-weight: 400;">
                        {{ TypebusinessRegister || "-" }}
                        <!-- {{dataOla.registerType === 'registerFull' ? 'ลงทะเบียนธุรกิจฉบับเต็ม' : 'ลงทะเบียนธุรกิจฉบับย่อ'}} -->
                      </p>
                    </v-col>
                    <v-col cols="12" class="form-control pl-5">
                      <p class="txt-head" style="margin-top: -20px; color: #333333;">
                        รูปแบบธุรกิจ
                      </p>
                      <p class="txt-font-value" style="margin-top: 0%; color: #333333; font-weight: 400;">
                        {{ businessModelType || "-" }}
                        <!-- {{dataOla.businessModelTypeTH}} -->
                      </p>
                    </v-col>
                  </v-row>
                  <v-divider class="mb-4"></v-divider>
                  <!-- ########################## รายละเอียดกิจการ #############################-->
                  <v-layout
                  class="pa-2 pr-2"
                  v-show="businessModelType === 'กิจการ'">
                  <v-row>
                      <v-col cols="12">
                        <span
                        class="txt-head"
                        style="font-size: 16px; color: #171F46;">
                        รายละเอียดกิจการ</span>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="12" xs="12">
                        <v-row>
                          <!-- ประเภทกิจการ ภาษาไทย -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ประเภทกิจการ ภาษาไทย
                            </p>
                            <!-- ไม่มีการเปลี่ยนประเภท ค่าเดิมที่มี -->
                            <span v-if="otherTypeNames === false || otherTypeNames === undefined"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ businessType || "-" }}
                            </span>
                            <!-- มีการเปลี่ยนประเภทใหม่ และยังไม่ถูกยืนยันการเปลี่ยนประเภท -->
                            <span v-if="otherTypeNames === true && statusChangeTypeNew === false"
                              class="txt-font-type"
                              style="margin-top: 0%;"
                            >
                              {{ businessType || "-" }}
                            </span>
                            <!-- มีการยืนยันเปลี่ยนประเภทใหม่ -->
                            <span v-if="statusChangeTypeNew === true && statusChangeTypeOld === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ businessType || "-" }}
                            </span>
                            <!-- มีการยืนยันเปลี่ยนเป็นประเภทเก่าที่มี -->
                            <span v-if="statusChangeTypeOld === true"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ nameTypeOldTh }}
                            </span>
                            <!-- แสดงในกรณี otherTypeNames มีค่าเป็น true จะแสดงปุ่มนี้ -->
                            <v-tooltip bottom v-if="otherTypeNames === true && statusChangeTypeNew === false">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  rounded
                                  dark
                                  icon
                                  class=""
                                  @click="dialogConfirmTypeNewTh = true"
                                >
                                <v-icon color="error" class="" small>mdi-alert-circle-outline</v-icon>
                                </v-btn>
                              </template>
                              <span class="label-table-action">มีการเพิ่มประเภทกิจการใหม่</span>
                            </v-tooltip>
                          </v-col>
                          <!-- ประเภทกิจการ ภาษาอังกฤษ **ใช้ข้อมมูลของภาษาไทยอยู่**-->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ประเภทกิจการ ภาษาอังกฤษ
                            </p>
                            <span v-if="statusChangeTypeOld === true"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ nameTypeOldEng }}
                            </span>
                            <span
                              v-else
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ businessTypeEng || "-" }}
                            </span>
                          </v-col>
                          <!-- ชื่อเต็มกิจการ ภาษาไทย -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อเต็มกิจการ ภาษาไทย
                            </p>
                            <p
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{companyNameFullTh || "-"}}
                            </p>
                          </v-col>
                          <!-- ชื่อย่อกิจการ ภาษาไทย -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                              ชื่อย่อกิจการ ภาษาไทย
                            </p>
                            <p
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ companyNameShortTh || "-" }}
                            </p>
                          </v-col>
                          <!-- ชื่อเต็มกิจการ ภาษาอังกฤษ -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                                  ชื่อเต็มกิจการ ภาษาอังกฤษ
                                </p>
                                <p
                                  class="txt-font-value"
                                  style="margin-top: 0%;"
                                >
                                  {{ companyNameFullEng || "-" }}
                                </p>
                          </v-col>
                          <!-- ชื่อย่อกิจการ ภาษาอังกฤษ -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                                  ชื่อย่อกิจการ ภาษาอังกฤษ
                                </p>
                                <p
                                  class="txt-font-value"
                                  style="margin-top: 0%;"
                                >
                                  {{ companyNameShortEng || "-" }}
                                </p>
                          </v-col>
                          <!-- หมายเลขเบอร์โทรศัพท์ -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                                  หมายเลขเบอร์โทรศัพท์
                                </p>
                                <p
                                  class="txt-font-value"
                                  style="margin-top: 0%;"
                                >
                                  {{ companyTelNo || "-" }}
                                </p>
                          </v-col>
                          <!-- อีเมล (ไม่จำเป็น) -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                                  อีเมล (ไม่จำเป็น)
                                </p>
                                <p
                                  class="txt-font-value"
                                  style="margin-top: 0%;"
                                >
                                  {{ email || "-" }}
                                </p>
                          </v-col>
                        </v-row>
                      </v-col>
                    <!-- รูปภาพ -->
                    <v-col cols="12" lg="4" md="4" sm="12" xs="12">
                      <v-col cols="12" class="form-control ml-lg-15 mr-lg-15 ml-md-0 mr-md-0 ml-sm-0 mr-sm-0">
                        <p class="txt-font" style="margin-top: 0%;">รูปเครื่องหมายการค้าหรือโลโก้</p>
                        <div
                              class="base-image-input elevation-0"
                              :style="{
                                'background-image': `url(${imageUrl})`
                              }"
                            >
                            <span v-if="!imageUrl" class="placeholder-image">
                              </span>
                              <input
                                class="file-input"
                                id="files"
                                ref="Pickfiles"
                                type="file"
                                v-on:change="onBannerSelected()"
                              />
                          </div>
                          <!-- <div>
                            <p>รูป</p>
                          <v-img width="150" height="110" :src="base64Img"/>
                          </div> -->
                      </v-col>
                    </v-col>
                  </v-row>
                </v-layout>
                 <!--########################## รายละเอียดนิติบุคคล ##########################-->
                 <v-layout
                    class="pa-2 pr-2"
                    v-show="businessModelType === 'นิติบุคคล'"
                  >
                    <v-row>
                      <v-col cols="12">
                        <span class="txt-head">รายละเอียดนิติบุคคล</span>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="12" xs="12">
                        <v-row>
                          <!-- ประเภทนิติบุคคล ภาษาไทย -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ประเภทนิติบุคคล ภาษาไทย
                            </p>
                            <span v-if="otherTypeNames === false || otherTypeNames === undefined"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ businessType || "-" }}
                            </span>
                             <span v-if="otherTypeNames === true && statusChangeTypeNew === false"
                              class="txt-font-type"
                              style="margin-top: 0%;"
                            >
                              {{ businessType || "-" }}
                            </span>
                            <span v-if="statusChangeTypeNew === true && statusChangeTypeOld === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ businessType || "-" }}
                            </span>
                            <span v-if="statusChangeTypeOld === true"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ nameTypeOldTh }}
                            </span>
                            <v-tooltip bottom v-if="otherTypeNames === true && statusChangeTypeNew === false">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  rounded
                                  dark
                                  icon
                                  class=""
                                  @click="dialogConfirmTypeNewTh = true"
                                >
                                <v-icon color="error" class="" small>mdi-alert-circle-outline</v-icon>
                                </v-btn>
                              </template>
                              <span class="label-table-action">มีการเพิ่มประเภทนิติบุคคลใหม่</span>
                            </v-tooltip>
                          </v-col>
                          <!-- ประเภทนิติบุคคล ภาษาอังกฤษ **ใช้ข้อมมูลของภาษาไทยอยู่** -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ประเภทนิติบุคคล ภาษาอังกฤษ
                            </p>
                            <span v-if="statusChangeTypeOld === true"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ nameTypeOldEng }}
                            </span>
                            <span
                              v-else
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ businessTypeEng || "-" }}
                            </span>
                          </v-col>
                          <!-- ชื่อเต็มบริษัท ภาษาไทย -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อเต็มบริษัท ภาษาไทย
                            </p>
                            <p
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ companyNameFullTh || "-" }}
                            </p>
                          </v-col>
                          <!-- ชื่อย่อบริษัท ภาษาไทย -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                              <p class="txt-font" style="margin-top: 0%;">
                                ชื่อย่อบริษัท ภาษาไทย (ไม่จำเป็น)
                              </p>
                              <p
                                class="txt-font-value"
                                style="margin-top: 0%;"
                              >
                                {{ companyNameShortTh || "-" }}
                              </p>
                          </v-col>
                          <!-- ชื่อเต็มบริษัท ภาษาอังกฤษ -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อเต็มบริษัท ภาษาอังกฤษ
                            </p>
                            <p
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ companyNameFullEng || "-" }}
                            </p>
                          </v-col>
                          <!-- ชื่อย่อบริษัท ภาษาอังกฤษ -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อย่อบริษัท ภาษาอังกฤษ (ไม่จำเป็น)
                            </p>
                            <p
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ companyNameShortEng || "-" }}
                            </p>
                          </v-col>
                          <!-- ชื่อสำหรับแสดงบนเอกสาร ภาษาไทย -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อสำหรับแสดงบนเอกสาร ภาษาไทย
                            </p>
                            <p
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ nameUseInDocTh || "-" }}
                            </p>
                          </v-col>
                          <!-- ชื่อสำหรับแสดงบนเอกสาร ภาษาอังกฤษ -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อสำหรับแสดงบนเอกสาร ภาษาอังกฤษ
                            </p>
                            <p
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ nameUseInDocEng || "-" }}
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <!-- รูปภาพ -->
                      <v-col cols="12" lg="4" md="4" sm="12" xs="12">
                        <v-col cols="12" class="form-control ml-lg-15 mr-lg-15 ml-md-0 mr-md-0 ml-sm-0 mr-sm-0">
                          <p class="txt-font" style="margin-top: 0%;">รูปเครื่องหมายการค้าหรือโลโก้</p>
                            <div
                              class="base-image-input elevation-0"
                              :style="{
                                'background-image': `url(${imageUrl})`
                              }"
                            >
                              <span v-if="!imageUrl" class="placeholder-image">
                              </span>
                              <input
                                class="file-input"
                                id="files"
                                ref="Pickfiles"
                                type="file"
                                v-on:change="onBannerSelected()"
                              />
                            </div>
                        </v-col>
                      </v-col>
                    </v-row>
                  </v-layout>
                  <!--########################## รายละเอียดองค์กร ##########################-->
                  <v-layout
                    class="pa-2 pr-2"
                    v-show="businessModelType === 'องค์กร'">
                    <v-row>
                      <v-col cols="12">
                        <span class="txt-head">รายละเอียดองค์กร</span>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="12" xs="12">
                        <v-row>
                          <!-- ประเภทองค์กร ภาษาไทย -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ประเภทองค์กร ภาษาไทย
                            </p>
                            <span
                              v-if="otherTypeNames === false || otherTypeNames === undefined"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ businessType || "-" }}
                            </span>
                            <span
                              v-if="otherTypeNames === true && statusChangeTypeNew === false"
                              class="txt-font-type"
                              style="margin-top: 0%;"
                            >
                              {{ businessType || "-" }}
                            </span>
                            <span
                              v-if="statusChangeTypeNew === true && statusChangeTypeOld === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ businessType || "-" }}
                            </span>
                            <span v-if="statusChangeTypeOld === true"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ nameTypeOldTh }}
                            </span>
                            <v-tooltip bottom v-if="otherTypeNames === true && statusChangeTypeNew === false">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  rounded
                                  dark
                                  icon
                                  class=""
                                  @click="dialogConfirmTypeNewTh = true"
                                >
                                <v-icon color="error" class="" small>mdi-alert-circle-outline</v-icon>
                                </v-btn>
                              </template>
                              <span class="label-table-action">มีการเพิ่มประเภทองค์กรใหม่</span>
                            </v-tooltip>
                          </v-col>
                          <!-- ประเภทองค์กร ภาษาอังกฤษ **ใช้ข้อมมูลของภาษาไทยอยู่**-->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ประเภทองค์กร ภาษาอังกฤษ
                            </p>
                            <span v-if="statusChangeTypeOld === true"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ nameTypeOldEng }}
                            </span>
                            <span
                              v-else
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ businessTypeEng || "-" }}
                            </span>
                          </v-col>
                          <!-- ชื่อเต็มบริษัท ภาษาไทย -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อเต็มบริษัท ภาษาไทย
                            </p>
                            <p
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ companyNameFullTh || "-" }}
                            </p>
                          </v-col>
                          <!-- ชื่อย่อบริษัท ภาษาไทย (ไม่จำเป็น) -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                              <p class="txt-font" style="margin-top: 0%;">
                                ชื่อย่อบริษัท ภาษาไทย (ไม่จำเป็น)
                              </p>
                              <p
                                class="txt-font-value"
                                style="margin-top: 0%;"
                              >
                                {{ companyNameShortTh || "-" }}
                              </p>
                          </v-col>
                          <!-- ชื่อเต็มบริษัท ภาษาอังกฤษ -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อเต็มบริษัท ภาษาอังกฤษ
                            </p>
                            <p
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ companyNameFullEng || "-" }}
                            </p>
                          </v-col>
                          <!-- ชื่อย่อบริษัท ภาษาอังกฤษ (ไม่จำเป็น) -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อย่อบริษัท ภาษาอังกฤษ (ไม่จำเป็น)
                            </p>
                            <p
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ companyNameShortEng || "-" }}
                            </p>
                          </v-col>
                          <!-- ชื่อสำหรับแสดงบนเอกสาร ภาษาไทย -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อสำหรับแสดงบนเอกสาร ภาษาไทย
                            </p>
                            <p
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ nameUseInDocTh || "-" }}
                            </p>
                          </v-col>
                          <!-- ชื่อสำหรับแสดงบนเอกสาร ภาษาอังกฤษ -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อสำหรับแสดงบนเอกสาร ภาษาอังกฤษ
                            </p>
                            <p
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ nameUseInDocEng || "-" }}
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <!-- รูปภาพ -->
                      <v-col cols="12" lg="4" md="4" sm="12" xs="12">
                        <v-col cols="12" class="form-control ml-lg-15 mr-lg-15 ml-md-0 mr-md-0 ml-sm-0 mr-sm-0">
                          <p class="txt-font" style="margin-top: 0%;">รูปเครื่องหมายการค้าหรือโลโก้</p>
                            <div
                              class="base-image-input elevation-0"
                              :style="{
                                'background-image': `url(${imageUrl})`
                              }"
                            >
                              <span v-if="!imageUrl" class="placeholder-image">
                              </span>
                              <input
                                class="file-input"
                                id="files"
                                ref="Pickfiles"
                                type="file"
                                v-on:change="onBannerSelected()"
                              />
                            </div>
                        </v-col>
                      </v-col>
                    </v-row>
                  </v-layout>
                <v-divider class="mb-4" v-show=" TypebusinessRegister =='ลงทะเบียนธุรกิจฉบับเต็ม'"></v-divider>
                <!-- #################################################### ที่อยู่กิจการ/ที่อยู่นิติบุคคล/ที่อยู่องค์กร #######################################-->
                  <v-layout class="pr-2 pl-2 mt-3" v-show=" TypebusinessRegister =='ลงทะเบียนธุรกิจฉบับเต็ม'">
                    <v-row>
                      <v-col cols="12" class="from-control">
                        <span
                          class="txt-head"
                          style="font-size: 16px; color: #171F46;"
                          v-show="businessModelType === 'กิจการ'"
                          >ที่อยู่กิจการ</span
                        >
                        <span
                          class="txt-head"
                          style="font-size: 16px; color: #171F46;"
                          v-show="businessModelType === 'นิติบุคคล'"
                          >ที่อยู่นิติบุคคล</span
                        >
                        <span
                          class="txt-head"
                          style="font-size: 16px; color: #171F46;"
                          v-show="businessModelType === 'องค์กร'"
                          >ที่อยู่องค์กร</span
                        >
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                          รหัสประจำที่อยู่
                        </p>
                        <p
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.codeAddress || "-" }}
                        </p>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">ที่อยู่</p>
                        <p
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.address || "-" }}
                        </p>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                          เลขที่ห้อง
                        </p>
                        <p
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.roomNo || "-" }}
                        </p>
                      </v-col>
                      <!-- อาคาร ชั้น = ต้องเปลี่ยนตัวแปรใหม่เพราะมันเอา 2 key มารวมกันจากเดิมที่แยกกัน ชั้น=floorNo อาคาร=buildingName-->
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">อาคาร, ชั้น</p>
                        <p
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.floorNo || "-" }}
                        </p>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">หมู่บ้าน</p>
                        <p
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.villageName || "-" }}
                        </p>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">หมู่ที่</p>
                        <p
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.villageNo || "-" }}
                        </p>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">ตรอก/ซอย</p>
                        <p
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.alley || "-" }}
                        </p>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">แยก</p>
                        <p
                          class="txt-font"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.dispart || "-" }}
                        </p>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">ถนน</p>
                        <p
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.road || "-" }}
                        </p>
                      </v-col>
                      <!-- จังหวัด -->
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">จังหวัด</p>
                        <p
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.province || "-" }}
                        </p>
                      </v-col>
                      <!-- อำเภอ -->
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                          อำเภอ/เขต
                        </p>
                        <p
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.district || "-" }}
                        </p>
                      </v-col>
                      <!-- ตำบล -->
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                          ตำบล/แขวง
                        </p>
                        <p
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.subDistrict || "-" }}
                        </p>
                      </v-col>
                      <!-- รหัสไปรษณีย์ -->
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                          รหัสไปรษณีย์
                        </p>
                        <p
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.postCode || "-" }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-layout>
              </v-card-subtitle>
              <v-divider class="mr-5 ml-5" v-show=" TypebusinessRegister =='ลงทะเบียนธุรกิจฉบับเต็ม'"></v-divider>
              <!-- ##################################### ผู้เสียภาษี ##################################################### -->
                <v-card-title
                  class="ra-head-text-bold pr-8 mb-3"
                  style="font-size: 16px; padding-left:24px;color: #171F46;"
                  v-show=" TypebusinessRegister =='ลงทะเบียนธุรกิจฉบับเต็ม'"
                >
                  ข้อมูลผู้เสียภาษี
                </v-card-title>
                <!-- ##################################### ข้อมูลผู้เสียภาษี ##################################################### -->
                <v-card-subtitle v-show=" TypebusinessRegister =='ลงทะเบียนธุรกิจฉบับเต็ม'">
                  <v-row class="">
                    <div class="pl-5">
                      <span class="txt-font-value">{{ taxDetailType }}</span>
                    </div>
                  </v-row>
                  <v-layout
                    class="pa-2 pr-2"
                    v-show="taxDetailType === 'มีข้อมูลผู้เสียภาษี'"
                  >
                    <v-row>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                          เลขที่ผู้เสียภาษีอากร
                        </p>
                        <p
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ taxId || "-" }}
                        </p>
                      </v-col>
                      <v-col
                        cols="12" lg="4" md="4" sm="6" xs="12"
                        class="form-control"
                      >
                        <p class="txt-font" style="margin-top: 0%;">อีเมล</p>
                        <p
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ email || "-" }}
                        </p>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                          ภูมิภาค/Region
                        </p>
                        <p
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ region || "-" }}
                        </p>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                          ชื่อสาขา
                        </p>
                        <p
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ branchName || "-" }}
                        </p>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                          รหัสสาขา
                        </p>
                        <p
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ branchCode || "-" }}
                        </p>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                          เบอร์โทรศัพท์
                        </p>
                        <p
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyTelNo || "-" }}
                        </p>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                          เบอร์ติดต่อเจ้าหน้าที่
                        </p>
                        <p
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyMobilNumber || "-" }}
                        </p>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">โทรสาร</p>
                        <p
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ fax || "-" }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-layout>
                </v-card-subtitle>
                <v-divider class="ml-5 mr-5" v-show=" TypebusinessRegister =='ลงทะเบียนธุรกิจฉบับเต็ม'"></v-divider>
                <v-card-title
                  v-show=" TypebusinessRegister =='ลงทะเบียนธุรกิจฉบับเต็ม'"
                  class="ra-head-text-bold pr-8"
                  style="font-size: 16px; padding-left:24px;color: #171F46;"
                >
                <span>เอกสารที่ต้องแนบ</span>
                </v-card-title>
                <v-card-subtitle v-show=" TypebusinessRegister =='ลงทะเบียนธุรกิจฉบับเต็ม'">
                  <v-row>
                    <div class="pl-5 pt-3">
                      <span class="txt-font-value">
                        {{docsDetailType}}</span>
                    </div>
                  </v-row>
                  <v-layout>
                    <v-row>
                      <v-col cols="4" md="3" sm="3" lg="4" xl="3" class="pl-5" v-show="docsDetailType === 'มีหนังสือรับรอง'">
                          <p class="txt-font" style="margin-top: 0%;">
                              หนังสือรับรองนิติบุคคล
                            </p>
                            <div class="mt-1">
                              <v-row>
                                <v-col cols="12">
                                  <v-btn
                                    v-if="filesCertificateId !== ''"
                                    id="btnbrowse"
                                    name="btnbrowse"
                                    outlined
                                    class="button-color-outline pa-2 align-center"
                                    @click="
                                        downloadFile(
                                          filesCertificateId,
                                          filesCertificateName,
                                          'certificate'
                                        )
                                    "
                                  >
                                    <v-icon left small class="icon-eye-color">mdi-tray-arrow-down</v-icon>
                                    <span class="txt-font" style="color:#2BA197">{{
                                      filesCertificateName
                                    }}</span>
                                  </v-btn>
                                  <span v-else class="txt-font">ไม่มี</span>
                                </v-col>
                                <!-- <v-col cols="6" class="form-control" v-if="documentId !== ''">
                                  <p class="txt-font" style="margin-top: 0%;">รหัสเอกสาร</p>
                                  <p
                                    class="txt-font-value"
                                    style="margin-top: 0%;"
                                  >
                                    {{ documentId || "-" }}
                                  </p>
                                </v-col>
                                <v-col cols="6" class="form-control">
                                  <p class="txt-font" style="margin-top: 0%;">รหัสผ่านเอกสาร</p>
                                  <p
                                    class="txt-font-value"
                                    style="margin-top: 0%;"
                                  >
                                    {{ documentId || "-" }}
                                  </p>
                                </v-col> -->
                              </v-row>
                            </div>
                            <div v-if="!checkboxpoa">
                              <span class="txt-font">ไม่มีผู้ดำเนินการแทน</span>
                            </div>
                           <div v-if="checkboxpoa">
                            <!-- <div v-if="!checkboxpoa"> -->
                            <p class="txt-font mt-2">
                              หนังสือมอบอำนาจ
                            </p>
                            <div class="mt-1">
                              <v-row>
                                <v-col cols="12">
                                  <v-btn
                                    v-if="poaName"
                                    id="btnbrowse"
                                    name="btnbrowse"
                                    outlined
                                    class="button-color-outline pa-2 align-center"
                                    @click="
                                        downloadFile(
                                          poaId,
                                          poaName,
                                          'powerOfAttorney'
                                        )
                                    "
                                  >
                                    <v-icon left small class="icon-eye-color">mdi-tray-arrow-down</v-icon>
                                    <span class="txt-font" style="color:#2BA197">{{
                                      poaName
                                    }}</span>
                                  </v-btn>
                                  <span v-else class="txt-font">-</span>
                               </v-col>
                              </v-row>
                            </div>
                           </div>
                      </v-col>
                    </v-row>
                  </v-layout>
                </v-card-subtitle>
                <v-divider class="ml-5 mr-5"></v-divider>
                <!-- ##################################### ผู้ดูแล ##################################################### -->
                <v-card-title
                  class="ra-head-text-bold pr-8"
                  style="font-size: 16px; padding-left:24px;color: #171F46;"
                >
                  ข้อมูลผู้ดูแล
                  <v-spacer></v-spacer>
                  <v-btn
                    v-show="editMode === true"
                    v-if="approver.length !== 0"
                    text
                    class="button-color-outline mb-2"
                    @click="openDialogAddAprover('add', '', '', 'approver')"
                  >
                    <v-icon left dark color="#2BA197" size="14px"
                      >fa-plus</v-icon
                    >
                    <span class="ra-text-in-button-business">
                      เพิ่มผู้ดูแล
                    </span>
                  </v-btn>
                </v-card-title>
                <!-- ##################################### ข้อมูลผู้ดูแล ##################################################### -->
                <v-card-subtitle>
                  <v-row v-if="approver.length === 0" class="mt-0 mb-8" justify=center>
                    <v-col cols="8" class="text-center">
                      <img width="150" height="110" src="@/assets/icons/emp-data-icon2.png">
                    </v-col>
                    <v-col cols="8" class="text-center" style="margin-top: -1%;">
                      <span class="" style="font-weight: bold;">ยังไม่มีข้อมูลผู้ดูแล</span>
                    </v-col>
                    <!-- <v-col cols="8" class="text-center" style="margin-top: -1%;">
                      <span class="ra-head-text">คลิกที่ปุ่มด้านล่างนี้เพื่อเพิ่มผู้ดูแลของคุณ</span>
                    </v-col> -->
                    <!-- ################ ปุ่มเพิ่มผู้ดูแล ################ -->
                    <!-- <v-col
                      cols="8"
                      class="pt-0 pb-0 d-flex align-center justify-center mt-4"
                      style="margin-top: -1%;"
                    >
                      <v-btn
                          outlined
                          class="button-color pl-5 pr-5"
                          dark
                          @click="openDialogAddAprover('add', '', '', 'approver')"
                        >
                        <v-icon left dark color="#fff" size="14px">fa-plus</v-icon>
                        <span class="">
                          เพิ่มผู้ดูแล
                        </span>
                      </v-btn>
                    </v-col> -->
                  </v-row>
            <v-row v-else>
              <v-col cols="12"
              >
                <v-data-table
                  :hide-default-footer="true"
                  :headers="headers"
                  :items="approver"
                  sort-by="no"
                  class="elevation-0"
                >
                <template v-slot:[`item.no`]="{ item }">
                  {{ approver.indexOf(item)+1 }}
                </template>
                <template v-slot:[`item.userImg`]="{ item }">
                  <td style="width: fit-content !important;" class="py-3">
                    <v-avatar
                      size="44"
                      rounded
                      >
                      <v-img
                        class="card-header-userimg-border"
                        cover
                        :src="item.failed_image ? require('@/assets/icons/no_user.png') : item.userImg"
                        :alt="item.employeeId"
                        v-on:error="onImgError(i)"
                        aspect-ratio="1"
                        height="100%"
                      />
                    </v-avatar>
                    </td>
                </template>
                  <!-- <template v-slot:top>
                    <v-toolbar
                      flat
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        outlined
                        color="primary"
                        dark
                        class="mb-2"
                        @click="openDialogAddAprover('add', '', '', 'approver')"
                      >
                      <v-icon left dark color="primary" size="14px">fa-plus</v-icon>
                      <span class="ra-text-in-button">
                        เพิ่มผู้ดูแล
                      </span>
                      </v-btn>
                    </v-toolbar>
                  </template> -->
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }"
                      >
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          rounded
                          small
                          dark
                          icon
                          class="ra-border-button mt-3 mb-3"
                          @click="openDialogAddAprover('edit', item, approver.indexOf(item), 'approver')"
                        >
                          <template v-slot>
                            <img width="17" height="17" src="@/assets/icons/edit-icon.png" >
                          </template>
                        </v-btn>
                      </template>
                      <span class="label-table-action">จัดการผู้ดูแล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ attrs }">
                        <v-btn
                          v-bind="attrs"
                          rounded
                          dark
                          small
                          icon
                          class="ra-border-button mt-3 mb-3 ml-2"
                          @click="checkRemove(item, 'approver')"
                        >
                          <template v-slot>
                            <img width="17" height="17" src="@/assets/icons/delete-icon.png" >
                          </template>
                        </v-btn>
                      </template>
                      <span class="label-table-action">ลบผู้ดูแล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
                </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
      </v-expansion-panels>
    </div>
    </v-form>
    <v-dialog v-model="dialogDeleteApprover" max-width="500px">
        <v-card height="170px" style="border-radius: 12px;">
          <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการลบข้อมูลนี้ ใช่หรือไม่?</v-card-title>
          <v-card-text class="justify-center text-center">
          <span v-if="titleDialog === 'approver'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้ดูแลคนนี้</span>
          <span v-else-if="titleDialog === 'temporaryer'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span>
          </v-card-text>
          <v-card-actions class="">
            <v-spacer></v-spacer>
            <v-btn class="button-color-outline" outlined @click="dialogDeleteApprover = false">ยกเลิก</v-btn>
            <v-btn class="button-color" dark @click="removeApprover(itemConfirmDelete, titleDialog)">ลบข้อมูล</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Dialog อนุมัติ/ไม่อนุมัติ -->
      <v-dialog
        v-model="dialogApproverCompany"
        persistent
        max-width="420"
        max-height="232">
        <v-card tile class="justify-center" style="border-radius: 12px;">
          <v-card-title
          class="txt-head justify-center pt-5"
          style="color: #2BA197; font-size: 18px;"
          >ต้องการ{{this.approveType}}คำร้องใช่ไหม</v-card-title>
          <v-card-text class="justify-center text-center">
          <span class="ra-head-text justify-center">คุณแน่ใจหรือไม่ว่าต้องการ{{this.approveType}}คำร้อง</span>
          <v-textarea v-model="comment" @keydown.space="preventLeadingSpace" class="ml-8 mr-8 mt-3" outlined rows="2" placeholder="ระบุความเห็น"></v-textarea>
          <div v-show ="getReliable === true && approveType === 'อนุมัติ'">
            <p class="ra-head-text pl-8" style="text-align: left;">ระบุ Business Level</p>
              <v-radio-group
                class="ra-head-text pl-8"
                v-model="businessLevel"
                row
              >
              <v-radio
                label="Business Level 1"
                color="#2BA197"
                value="1"
              ></v-radio>
              <v-radio
                label="Business Level 2"
                color="#2BA197"
                value="2"
              ></v-radio>
            </v-radio-group>
          </div>
          <!-- <v-text-field
          v-show ="approveType === 'อนุมัติ'"
          type="number"
          v-model="businessLevel"
          class="ml-8 mr-8 mt-3"
          outlined
          rows="2"
          placeholder="Business Level"></v-text-field> -->
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn class="button-color-outline" outlined @click="dialogApproverCompany = false, comment = '', businessLevel = null">ยกเลิก</v-btn>
            <!-- กรณีจะกดยืนยันได้ต้อง comment ก่อน -->
            <v-btn v-if="comment === '' && businessLevel === null && approveType === 'ไม่อนุมัติ'" class="ra-button1" color="grey" depressed disabled>ยืนยัน</v-btn>
            <v-btn v-else class="button-color" dark @click="updateStatusApprove(approveType)">ยืนยัน</v-btn>
            <!-- <v-btn class="ra-button1" color="#2BA197" dark @click="updateStatusApprove(approveType)">ยืนยัน</v-btn> -->
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- <div class="text-center">
        <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          text
          top
          app
        >
        <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
        <span :style="{ 'color': `${snackbarColor}` }">{{ text }}</span>
        </v-snackbar>
      </div> -->
      <div class="text-center">
      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="snackbarColor"
        text
        top
        app
      >
        <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
        <span :style="{ color: `${snackbarColor}` }">{{ text }}</span>
      </v-snackbar>
    </div>
        <!-- ### Test snackbar ### -->
        <!-- <div class="text-center">
      <v-snackbar
        v-model="snackbar"
        :color="colors"
        :timeout="timeout"
        top = true
      >
      <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
        {{ textsnackbar }}
        <template v-slot:action="{ attrs }">
          <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </div> -->
    <DialogAddAprover/>
     <!-- dialog เปลี่ยนประเภทไทยใหม่ -->
      <v-dialog
      v-model="dialogConfirmTypeNewTh"
      persistent
      max-width="420"
      max-height="500"
      style="z-index: 9999;"
    >
      <!-- <v-card tile class="pt-3 pb-3 justify-center" style="border-radius: 12px;">
        <div class="d-flex justify-end mr-3">
            <v-btn
                  rounded
                  dark
                  small
                  class="mr-2"
                  icon
                  @click="dialogConfirmTypeNewTh = false"
                >
                <v-icon color="#757575" class="ml-auto">mdi-close</v-icon>
                </v-btn>
          </div> -->
        <v-card tile class="justify-center">
          <v-card-title class="justify-center">
          <span style="font-family: Sarabun; font-style: normal; font-weight: bold; font-size: 16px; line-height: 22px; text-align: center; color: #2BA197;">
            คุณต้องการบันทึกข้อมูลประเภท{{businessModelType}}ใช่หรือไม่
          </span>
        </v-card-title>
        <v-card-subtitle class="layout justify-center pt-1">
          <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #757575; margin-top: 12px;">
           คุณแน่ใจใช่หรือไม่ว่า<br>ต้องการเพิ่มข้อมูลประเภท <b>"{{businessType}}"</b> ชนิดนี้
          </span>
        </v-card-subtitle>
        <div class="justify-center">
          <v-btn
            color="#2BA197"
            dark
            class="head-search-button mx-10 mt-2 mb-2 white--text text--lighten-4"
            width="340"
            @click="changeType('new')"
          >
          ฉันแน่ใจ และบันทึกข้อมูล
          </v-btn>
          <v-btn
            color="#2BA197"
            class="head-search-button mx-10 mt-2 mb-2"
            width="340"
            outlined
            @click="dialogConfirmChangeTypeTh = true"
          >
          ฉันไม่แน่ใจ ไปยังขั้นตอนถัดไป
          </v-btn>
          <v-btn
            color="#2BA197"
            class="ml-10 mt-2 mb-2 black--text text--lighten-4"
            width="340"
            text
            @click="dialogConfirmTypeNewTh = false"
          >
          ยกเลิก
          </v-btn>
        </div>
        </v-card>
      </v-dialog>
    <!-- dialog เปลี่ยนประเภทไทยที่มีอยู่ -->
      <v-dialog
      v-model="dialogConfirmChangeTypeTh"
      persistent
      max-width="420"
      height="500"
      style="z-index: 9999;"
    >
      <v-card tile class="justify-center pt-10 pb-10" style="border-radius: 12px;">
        <v-card-title class="justify-center">
          <span class="mb-5" style="font-family: Sarabun; font-style: normal; font-weight: bold; font-size: 18px; line-height: 22px; text-align: center; color: #2BA197;">
            ต้องการเปลี่ยนแปลงประเภท{{businessModelType}}ใช่ไหม
          </span>
        </v-card-title>
       <v-card-text>
         <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 15px; line-height: 22px; text-align: center; color: #757575; margin-top: 12px;">
           กรุณาเลือกประเภท{{businessModelType}}ภาษาไทยที่ต้องการแก้ไข
          </span>
          <v-autocomplete
            class="mt-2"
            v-if="businessModelType === 'กิจการ'"
            v-model="businessNewTypeTh"
            :items="itemBusiness"
            item-text="name"
            item-value="_id"
            placeholder="เลือกประเภทกิจการ"
            dense
            outlined
          ></v-autocomplete>
          <v-autocomplete
            class="mt-2"
            v-if="businessModelType === 'นิติบุคคล'"
            v-model="businessNewTypeTh"
            :items="itemlegalEntity"
            item-text="name"
            item-value="_id"
            placeholder="เลือกประเภทนิติบุคคล"
            dense
            outlined
          ></v-autocomplete>
          <v-autocomplete
            class="mt-2"
            v-if="businessModelType === 'องค์กร'"
            v-model="businessNewTypeTh"
            :items="itemOrganization"
            item-text="name"
            item-value="_id"
            placeholder="เลือกประเภทองค์กร"
            dense
            outlined
          ></v-autocomplete>
       </v-card-text>
        <v-card-actions class="mt-n4">
          <v-spacer></v-spacer>
          <v-btn
            class="button-color-outline mr-3"
            width="100"
            outlined
            @click="dialogConfirmChangeTypeTh = false"
          >
          ย้อนกลับ
          </v-btn>
          <v-btn
            class="button-color white--text text--lighten-4"
            width="100"
            @click="changeType('old')"
          >
          บันทึกข้อมูล
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
      </v-dialog>
    <!-- dialog เปลี่ยนประเภทอังกฤษใหม่ -->
      <!-- <v-dialog
      v-model="dialogConfirmTypeNewEng"
      persistent
      max-width="420"
      max-height="500"
      style="z-index: 9999;"
    >
      <v-card tile class="pt-3 pb-3 justify-center" style="border-radius: 12px;">
        <div class="d-flex justify-end mr-3">
            <v-btn
                  rounded
                  dark
                  small
                  class="mr-2"
                  icon
                  @click="dialogConfirmTypeNewEng = false"
                >
                <v-icon color="#757575" class="ml-auto">mdi-close</v-icon>
                </v-btn>
          </div>
        <v-card-title class="justify-center">
          <span style="font-family: Sarabun; font-style: normal; font-weight: bold; font-size: 17px; line-height: 22px; text-align: center; color: #2BA197;">
            คุณต้องการบันทึกข้อมูลประเภท{{businessModelType}}ใช่หรือไม่
          </span>
        </v-card-title>
        <v-card-subtitle class="layout justify-center pt-3">
          <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #757575; margin-top: 12px;">
           คุณแน่ใจใช่หรือไม่ว่า<br>ต้องการเพิ่มข้อมูลประเภท <b>"{{businessTypeEng}}"</b> ชนิดนี้
          </span>
        </v-card-subtitle>
        <v-card-actions class="justify-center">
          <div class="pt-3 justify-center">
          <v-btn
            dark
            class="button-color mb-2 ml-lg-16 ml-md-16 ml-sm-16 ml-xs-16 white--text text--lighten-4"
            width="290"
            @click="changeType('new')"
          >
          ฉันแน่ใจ และบันทึกข้อมูล
          </v-btn>
          <v-btn
            class="button-color-outline mt-2 mb-2 ml-lg-16 ml-md-16 ml-sm-16 ml-xs-16"
            width="290"
            outlined
            @click="dialogConfirmChangeTypeEng = true"
          >
          ฉันไม่แน่ใจ ไปยังขั้นตอนถัดไป
          </v-btn>
        </div>
        </v-card-actions>
      </v-card>
      </v-dialog> -->
    <!-- dialog เปลี่ยนประเภทอังกฤษที่มีอยู่ -->
      <!-- <v-dialog
      v-model="dialogConfirmChangeTypeEng"
      persistent
      max-width="420"
      height="500"
      style="z-index: 9999;"
    >
      <v-card tile class="justify-center pt-10 pb-10" style="border-radius: 12px;">
        <v-card-title class="justify-center">
          <span class="mb-5" style="font-family: Sarabun; font-style: normal; font-weight: bold; font-size: 18px; line-height: 22px; text-align: center; color: #2BA197;">
            ต้องการเปลี่ยนแปลงประเภท{{businessModelType}}ใช่ไหม
          </span>
        </v-card-title>
       <v-card-text>
         <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 15px; line-height: 22px; text-align: center; color: #757575; margin-top: 12px;">
           กรุณาเลือกประเภท{{businessModelType}}ภาษาอังกฤษที่ต้องการแก้ไข
          </span>
          <v-autocomplete
            class="mt-2"
            v-if="businessModelType === 'กิจการ'"
            v-model="businessNewTypeEng"
            :items="itemBusiness"
            item-text="nameEn"
            item-value="_id"
            placeholder="เลือกประเภทกิจการ"
            dense
            outlined
          ></v-autocomplete>
          <v-autocomplete
            class="mt-2"
            v-if="businessModelType === 'นิติบุคคล'"
            v-model="businessNewTypeEng"
            :items="itemlegalEntity"
            item-text="nameEn"
            item-value="_id"
            placeholder="เลือกประเภทนิติบุคคล"
            dense
            outlined
          ></v-autocomplete>
          <v-autocomplete
            class="mt-2"
            v-if="businessModelType === 'องค์กร'"
            v-model="businessNewTypeEng"
            :items="itemOrganization"
            item-text="nameEn"
            item-value="_id"
            placeholder="เลือกประเภทองค์กร"
            dense
            outlined
          ></v-autocomplete>
       </v-card-text>
        <v-card-actions class="mt-n4">
          <v-spacer></v-spacer>
          <v-btn
            class="button-color-outline mr-3"
            width="100"
            outlined
            @click="dialogConfirmChangeTypeEng = false"
          >
          ย้อนกลับ
          </v-btn>
          <v-btn
            class="button-color white--text text--lighten-4"
            width="100"
            @click="changeType('old')"
          >
          บันทึกข้อมูล
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
      </v-dialog> -->
      <!-- เปลี่ยนเวอร์ชั่น -->
      <v-dialog v-model="dialogChangeVer" max-width="550px" persistent>
      <v-card>
        <v-card-title class="ra-head-text-bold justify-center pa-5"
          >ต้องการเปลี่ยนเวอร์ชั่นข้อมูลธุรกิจใช่ไหม</v-card-title
        >
        <v-card-text class="justify-center text-center">
          <span class="ra-head-text justify-center" style="font-size: 16px;"
            >คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนเวอร์ชั่นข้อมูลธุรกิจ</span
          >
        </v-card-text>
        <v-card-text class="justify-center text-center">
          <v-btn
            class="ra-button1 mb-3"
            width="70%"
            color="#1654C6"
            dark
            @click="submitDataCreate()"
            >ฉันแน่ใจ และบันทึกข้อมูล</v-btn
          >
          <v-btn
            class="ra-button1 mb-3"
            width="70%"
            color="#1654C6"
            outlined
            @click="getDetailVersion(versionDate)"
            >ฉันแน่ใจ และไม่บันทึกข้อมูล
          </v-btn>
          <v-btn
            class="ra-button1 mb-3"
            width="70%"
            color="#757575"
            text
            outlined
            dark
            @click="cancelVersion()"
            >ยกเลิก</v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import swal from 'sweetalert'
import { EventBus } from '@/EventBus'
import FileSaver from 'file-saver'
import DialogAddAprover from '../../manageCompany/_dialog/dialogAddApprover'
import { getUserByKeyword, insertApproveCompany } from '@/API/API'
const axios = require('axios')

export default {
  components: {
    DialogAddAprover
  },
  name: 'overview',
  data () {
    return {
      itemVersion: [], // Version
      versionDate: '', // version
      versionDateOld: '', // version
      status: '',
      businessLevel: null, // Level 1 2
      databussinessLevel: '', // ข้อมูลส่ง level ถ้าเป็น 0 คือไม่มีเอกสารแนบ
      approveRole: localStorage.approveRole,
      snackbar: false,
      textsnackbar: 'Test snack bar',
      colors: 'success',
      timeout: 5000,
      snackbarColor: '',
      text: '',
      itemBusiness: [], // ตัวเลือกประเภทกิจการ
      itemlegalEntity: [], // ตัวเลือกประเภทนิติบุคคล
      itemOrganization: [], // ตัวเลือกประเภทองค์กร
      businessNewTypeTh: '', // ประเภทไทย
      businessNewTypeEng: '', // ประเภทอิ้ง
      // legalEntityNewType: '', // ประเภทนิติบุคคล
      // organizationNewType: '', // ประเภทองค์กร
      dialogChangeVer: false, // dialog เปลี่ยนเวอร์ชั่น
      dialogConfirmTypeNewTh: false, // dialog เปลี่ยนประเภทใหม่ไทย
      dialogConfirmTypeNewEng: false, // dialog เปลี่ยนประเภทใหม่อังกฤษ
      dialogConfirmChangeTypeTh: false, // dialog เปลี่ยนประเภทที่มีอยู่ไทย
      dialogConfirmChangeTypeEng: false, // dialog เปลี่ยนประเภทที่มีอยู่อิ้ง
      statusChangeTypeNew: false, // เอาไว้เช็คว่ามีการบันทึกเปลี่ยนแปลงประเภทใหม่หรือยัง
      statusChangeTypeOld: false, // เอาไว้เช็คว่ามีการบันทึกเปลี่ยนแปลงประเภทเก่าหรือยัง
      idOtherTypeNamesTh: '', // เก็บค่า id ของประเภท ไทย
      idOtherTypeNamesEng: '', // เก็บค่า id ของประเภท อิ้ง
      nameTypeOldTh: '', // เก็บค่าของการเลือกประเภทเก่าไทย
      nameTypeOldEng: '', // เก็บค่าของการเลือกประเภทเก่าอิ้ง
      dataComment: '',
      dialogDeleteApprover: false,
      dialogApproverCompany: false,
      commentcard: false,
      reqBusinessId: '',
      getId: '',
      comment: '',
      commentUpdate: '',
      approveType: '',
      titleDialog: '',
      itemConfirmDelete: [],
      panel: [0, 1],
      businessType: '',
      organizationType: '',
      TypebusinessRegister: 'ลงทะเบียนธุรกิจฉบับเต็ม', // รูปแบบธุรกิจ Default
      taxDetailType: 'ไม่มีข้อมูลผู้เสียภาษี',
      businessModelType: '', // รูปแบบธุรกิจ
      businessModelTypeEng: '', // รูปแบบธุรกิจอิ้ง
      docsDetailType: 'ไม่มีหนังสือรับรอง', // รูปแบบหนังสือรับรอง
      chkReject: false,
      chkCancel: false,
      chkApprove: false,
      chkDataEmp: 0,
      imageData: null,
      legalEntityTh: '',
      otherTypeNames: '',
      legalEntityEng: '',
      nameUseInDocTh: '',
      nameUseInDocEng: '',
      groupName: '',
      companyNameEng: '',
      companyNameTh: '',
      itemCompany: [],
      taxId: '',
      email: '',
      branchName: '',
      branchCode: '',
      companyTelNo: '',
      companyMobilNumber: '',
      fax: '',
      companyAddressDetail: {
        codeAddress: '',
        address: '',
        roomNo: '',
        floorNo: '',
        buildingName: '',
        villageName: '',
        villageNo: '',
        alley: '',
        dispart: '',
        road: '',
        province: '',
        district: '',
        subDistrict: '',
        postCode: ''
      },
      region: '',
      companyNameFullEng: '',
      companyNameFullTh: '',
      companyNameShortEng: '',
      companyNameShortTh: '',
      address: '',
      files: [],
      filesCertificate: [],
      filesPoa: [],
      filesAuth: [],
      filesCertificateId: '',
      filesCertificateName: '',
      poaId: '',
      poaName: '',
      checkboxpoa: false,
      tel: '',
      img: '',
      tab: null,
      imageUrl: '',
      type_files: ['pdf', 'png', 'jpg', 'jpeg', 'tiff', 'gif', 'rar', 'zip', '7z'],
      statusById: '',
      items: [
        'เครือ(กรุ๊ปบริษัท)', 'จัดการบริษัท'
      ],
      userDataStore: '',
      tokenUser: '',
      userIdList: [],
      userIdListTemporary: [],
      approver: [],
      temporaryer: [],
      isSelecting: false,
      valid: true,
      progressColor: '',
      progressValue: '',
      editMode: false,
      inputRules: [
        v => !!v || 'กรุณากรอกข้อมูล'
      ],
      headers: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        // { text: 'รูป', value: 'userImg' },
        // { text: 'รหัสพนักงาน', value: 'employeeId' },
        { text: 'ชื่อ-นามสกุล', value: 'approverName' },
        // { text: 'ตำแหน่ง', value: 'position' },
        { text: 'อีเมล', value: 'email' },
        { text: 'เบอร์โทรศัพท์', value: 'tel' }
        // { text: 'จัดการ', value: 'actions', sortable: false }
      ],
      headersTemporary: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'รูป', value: 'userImg' },
        { text: 'รหัสพนักงาน', value: 'employeeId' },
        { text: 'ชื่อ-นามสกุล', value: 'approverName' },
        { text: 'ตำแหน่ง', value: 'position' },
        { text: 'อีเมล', value: 'email' },
        { text: 'วันที่รักษาการ', value: '' },
        { text: 'เอกสาร', value: '' },
        { text: 'จัดการ', value: 'actions', sortable: false }
      ],
      statusList: [
        { status: 'pending', statusTH: 'รออนุมัติ', color: '#E9A016' },
        { status: 'approve', statusTH: 'อนุมัติแล้ว', color: '#58A144' },
        { status: 'reject', statusTH: 'ไม่อนุมัติ', color: '#D1392B' },
        { status: 'cancel', statusTH: 'ยกเลิก', color: '#757575' },
        { status: 'acknowledge', statusTH: 'รับทราบแล้ว', color: '#58A144' }
      ],
      getStatus: '',
      getReliable: Boolean,
      dataEdit: '',
      dataOla: '',
      base64Img: '',
      isEdit: false,
      businessTypeEng: ''
    }
  },
  mounted () {
    EventBus.$on('addAprover', this.add)
    EventBus.$on('setApproveRole', this.setApproveRole)
  },
  beforeDestroy () {
    EventBus.$off('addAprover')
    EventBus.$off('setApproveRole')
  },
  async created () {
    this.loading = true
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    this.propsitems = this.$route.params.id
    this.reqBusinessId = this.$route.params.id
    this.getId = this.$route.params._id
    this.getStatus = this.$route.params.status
    this.dataComment = this.$route.params.comment
    this.getReliable = this.$route.params.reliable
    this.isEdit = this.$route.params.isEdit
    if (!this.$store.state.token) {
      this.goBack()
    } else {
      this.getSelectCompany()
      // await this.getDataEdit(this.getId)
      await this.getCompanyDetail(this.propsitems)
      await this.getSelectbusinessType()
      // console.log('getStatus', this.getStatus)
      // console.log('getReliable', this.getReliable)
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    // ป้องกันการกรอก Spacebar
    preventLeadingSpace (e) {
      // ป้องกันการกด spacebar ถ้ายังไม่มีการกรอกข้อมูล
      if (!e.target.value) e.preventDefault()
      // ถ้าหากอักขระนำหน้าเป็นช่องว่าง ให้ลบช่องว่างนำหน้าทั้งหมดออก
      else if (e.target.value[0] === ' ') e.target.value = e.target.value.replace(/^\s*/, '')
    },
    async getSelectbusinessType () {
      await this.axios({
        method: 'get',
        url: `${this.api}/api/vMonk/selector/businessType?businessType=${this.businessModelTypeEng}`
      })
        .then(response => {
          if (this.businessModelTypeEng === 'market') {
            this.itemBusiness = response.data.selector
          } else if (this.businessModelTypeEng === 'corporation') {
            this.itemlegalEntity = response.data.selector
          } else {
            this.itemOrganization = response.data.selector
          }
          // console.log('businessType', response.data.selector)
        })
        .catch(e => {
          console.log(e)
        })
    },
    async chageVersion (value) {
      this.versionDateOld = value
      if (this.editMode === true) {
        this.dialogChangeVer = true
      } else {
        await this.getDetailVersion(this.versionDateOld)
      }
    },
    async cancelVersion () {
      this.dialogChangeVer = false
      this.versionDate = this.versionDateOld
      await this.getDetailVersion(this.versionDateOld)
    },
    async getDetailVersion (id) {
      const tempApprover = []
      this.approver = []
      this.userIdList = []
      this.dialogChangeVer = false
      this.loading = true
      var itemVersionDetail = this.itemVersion.filter(e => e._id === id)
      if (itemVersionDetail[0].businessModelType === 'market') {
        this.businessModelType = 'กิจการ'
      } else if (itemVersionDetail[0].businessModelType === 'corporation') {
        this.businessModelType = 'นิติบุคคล'
      } else {
        this.businessModelType = 'องค์กร'
      }
      this.businessType = itemVersionDetail[0].businessType
      this.businessTypeEng = itemVersionDetail[0].businessTypeEn
      this.taxDetailType = itemVersionDetail[0].taxDetail === false ? 'ไม่มีข้อมูลผู้เสียภาษี' : 'มีข้อมูลผู้เสียภาษี'
      this.docsDetailType = itemVersionDetail[0].docDetail === false ? 'ไม่มีหนังสือรับรอง' : 'มีหนังสือรับรอง'
      this.companyNameShortTh = itemVersionDetail[0].companyShortNameTh
      this.companyNameShortEng = itemVersionDetail[0].companyShortNameEng
      this.legalEntityTh = itemVersionDetail[0].legalEntityTh
      this.companyNameFullTh = itemVersionDetail[0].companyFullNameTh
      this.nameUseInDocTh = itemVersionDetail[0].nameUseInDocTh
      this.legalEntityEng = itemVersionDetail[0].legalEntityEng
      this.companyNameFullEng = itemVersionDetail[0].companyFullNameEng
      this.nameUseInDocEng = itemVersionDetail[0].nameUseInDocEng
      this.taxId = itemVersionDetail[0].taxId
      this.email = itemVersionDetail[0].email
      // this.taxemail = itemVersionDetail[0].taxemail
      this.region = itemVersionDetail[0].region
      this.branchName = itemVersionDetail[0].branchName
      this.branchCode = itemVersionDetail[0].branchCode
      this.companyTelNo = itemVersionDetail[0].companyTelNo
      // this.taxTelNo = itemVersionDetail[0].taxTelNo
      this.companyMobilNumber = itemVersionDetail[0].companyMobilNumber
      this.fax = itemVersionDetail[0].fax
      this.companyAddressDetail.codeAddress =
        itemVersionDetail[0].companyAddressDetail.codeAddress
      this.companyAddressDetail.address =
        itemVersionDetail[0].companyAddressDetail.address
      this.companyAddressDetail.roomNo =
        itemVersionDetail[0].companyAddressDetail.roomNo
      this.companyAddressDetail.floorNo =
        itemVersionDetail[0].companyAddressDetail.floorNo
      this.companyAddressDetail.buildingName =
        itemVersionDetail[0].companyAddressDetail.buildingName
      this.companyAddressDetail.villageName =
        itemVersionDetail[0].companyAddressDetail.villageName
      this.companyAddressDetail.villageNo =
        itemVersionDetail[0].companyAddressDetail.villageNo
      this.companyAddressDetail.alley =
        itemVersionDetail[0].companyAddressDetail.alley
      this.companyAddressDetail.dispart =
        itemVersionDetail[0].companyAddressDetail.dispart
      this.companyAddressDetail.road =
        itemVersionDetail[0].companyAddressDetail.road
      this.companyAddressDetail.province =
        itemVersionDetail[0].companyAddressDetail.province
      this.companyAddressDetail.district =
        itemVersionDetail[0].companyAddressDetail.district
      this.companyAddressDetail.subDistrict =
        itemVersionDetail[0].companyAddressDetail.subDistrict
      this.companyAddressDetail.postCode =
        itemVersionDetail[0].companyAddressDetail.postCode
      this.filesCertificateId = itemVersionDetail[0].companyCertificate
      this.filesCertificateName = itemVersionDetail[0].companyCertificateName
      this.poaId = itemVersionDetail[0].powerOfAttorney
      this.poaName = itemVersionDetail[0].powerOfAttorneyName
      this.checkboxpoa = itemVersionDetail[0].checkboxpoa
      this.versionDate = this.versionDateOld
      // ไม่ได้ใช้
      // this.progressValue = itemVersionDetail[0].reliability
      // this.progressColor =
      //   this.progressValue <= 30
      //     ? '#F37959'
      //     : this.progressValue > 30 && this.progressValue <= 61
      //       ? '#F2BE47'
      //       : this.progressValue > 61 && this.progressValue <= 79
      //         ? '#3D5D85'
      //         : '#6FB540'
      // this.imageUrl = `${this.api}/api/vMonk/companys/getcompanyFileById/` + itemVersionDetail[0].companyImage
      var imagesUrlCompany = itemVersionDetail[0].companyImage
      this.axios({
        method: 'get',
        responseType: 'data',
        url:
          `${this.api}/api/vMonk/companys/getcompanyFileById/` +
          imagesUrlCompany
      })
        .then(response => {
          // console.log('test value', imagesUrlCompany)
          this.imageUrl = this.imageUrl =
            `${this.api}/api/vMonk/companys/getcompanyFileById/` +
            imagesUrlCompany
        })
        .catch(e => {
          // console.log('test value', imagesUrlCompany)
          this.imageUrl =
            `${this.api}/api/vMonk/companys/getcompanyFileById/` +
            imagesUrlCompany
          console.log(e)
        })
      if (itemVersionDetail[0].userData !== '') {
        itemVersionDetail[0].userData.map((el, index) => {
          // el.companyImage = `${this.api}/api/vMonk/companys/getcompanyFileById/` + el.companyImage
          tempApprover.push({
            approverNo: this.approver.length + 1,
            approverName: el.titleTh + el.firstNameTh + ' ' + el.lastNameTh,
            email: el.emailOneId,
            tel: el.tel,
            failed_image: false,
            ...el
          })
          this.userIdList.push({
            userId: el.employeeId,
            companyId: el.companyId
          })
          this.approver = tempApprover
        })
      } else {
        this.approver = itemVersionDetail[0].companyLeader
      }
      var pathFileName = 'uploads/companyFile/' + this.companyNameFullEng + '/'
      var substringsCertificate = itemVersionDetail[0].companyCertificate.split(
        pathFileName,
        2
      )
      var substringsPoa = itemVersionDetail[0].powerOfAttorney.split(
        pathFileName,
        2
      )
      this.filesPoa.push({
        name: substringsPoa[1]
      })
      this.filesCertificate.push({
        name: substringsCertificate[1]
      })
      setTimeout(() => {
        this.editMode = false
        this.loading = false
      }, 500)
      // this.dialogEdit = value
    },
    goBack () {
      this.$router.push('/manageapprovebusiness')
    },
    cancel () {
      this.files[0] = []
      this.groupName = ''
      this.filesCertificate[0] = []
      this.filesPoa[0] = []
      this.companyNameShortTh = ''
      this.companyNameShortEng = ''
      this.legalEntityTh = ''
      this.companyNameFullTh = ''
      this.nameUseInDocTh = ''
      this.taxId = ''
      this.email = ''
      this.taxId = ''
      this.region = ''
      this.branchName = ''
      this.branchCode = ''
      this.branchName = ''
      this.companyMobilNumber = ''
      this.companyAddressDetail = ''
      this.userIdList = []
      this.userIdListTemporary = []
      this.approver = []
      this.temporaryer = []
      this.$router.go(-1)
    },
    async setApproveRole () {
      this.approveRole = localStorage.approveRole
      await this.getCompanyDetail(this.propsitems)
    },
    onImgError (i) {
      // console.log('method: ', i)
      this.approver[i].failed_image = true
    },
    async getSelectCompany () {
      await this.axios({
        method: 'get',
        url: `${this.api}/api/vMonk/companys/selectGroupCompany`
      }).then((response) => {
        var dataReverse = response.data.result
        this.itemCompany = dataReverse
        // console.log('revers/e', this.itemCompany)
        this.itemCompany.push({
          _id: '',
          groupCompanyNameEng: 'ไม่มี'
        })
        this.itemCompany = this.itemCompany.reverse()
      }).catch(e => {
        console.log(e)
      })
    },
    async getUserDefault () {
      this.loading = true
      this.loadingUsers = true
      const obj = {
        search: this.$store.state.user.employeeId
      }
      try {
        const res = await getUserByKeyword(obj, this.tokenUser)
        if (res.success) {
          var filterValue = this.approver.filter(r => {
            if (r.position === res.result[0].position.positionName && r._id === res.result[0].id && r.approverName === res.result[0].name) {
              return r
            }
          })
          if (filterValue.length > 0) {
            swal('คำเตือน', 'คูณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
          } else {
            this.approver.push({
              approverNo: this.approver.length + 1,
              _id: res.result[0].id,
              employeeId: res.result[0].employeeId,
              approverName: res.result[0].name,
              position: res.result[0].position.positionName,
              email: res.result[0].email,
              userImg: this.api + '/' + res.result[0].userImg,
              approveType: res.result[0].approveType,
              companyId: res.result[0].companyId,
              failed_image: false
            })
            this.userIdList.push({
              userId: res.result[0].id,
              companyId: res.result[0].companyId
            })
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
        this.loadingUsers = false
      }
    },
    async downloadFile (value, nameFile, type) {
      if (value.length < 30) {
        await this.axios({
          method: 'get',
          responseType: 'blob',
          url: `${this.api}/api/vMonk/companys/getcompanyFileById/` + value
        }).then((response) => {
          FileSaver.saveAs(new Blob([response.data]), nameFile)
        }).catch(e => {
          console.log(e)
        })
      } else {
        await this.axios({
          method: 'get',
          responseType: 'blob',
          url: `${this.api}/api/vMonk/organization/file/${this.getId}/${type}` // type เป็น certificate,powerOfAttorney
        }).then((response) => {
          FileSaver.saveAs(new Blob([response.data]), nameFile)
        }).catch(e => {
          console.log(e)
        })
      }
    },
    async getFormAuth () {
      await this.axios({
        method: 'get',
        responseType: 'blob',
        url: `${this.api}/api/vMonk/companys/downloadPOA`
      }).then((response) => {
        FileSaver.saveAs(new Blob([response.data]), 'หนังสือมอบอำนาจ.doc')
      }).catch(e => {
        console.log(e)
      })
    },
    async getFormPoa () {
      await this.axios({
        method: 'get',
        responseType: 'blob',
        url: `${this.api}/api/vMonk/companys/downloadSPOA`
      }).then((response) => {
        FileSaver.saveAs(new Blob([response.data]), 'หนังสือมอบอำนาจช่วง.docx')
      }).catch(e => {
        console.log(e)
      })
    },
    async getCompanyDetail (id) {
      if (this.isEdit === false) {
        await this.axios({
          method: 'GET',
          url: `${this.api}/api/vMonk/organization/` + id,
          headers: {
            authorization: this.$store.state.token
          }
        }).then((response) => {
          this.businessType = response.data.result.businessType // ประเภท
          this.businessTypeEng = response.data.result.businessTypeEn // ประเภท
          this.businessModelType = response.data.result.businessModelTypeTH // รูปแบบธุรกิจไทย
          this.businessModelTypeEng = response.data.result.businessModelType // รูปแบบธุรกิจอิ้ง
          this.organizationType = response.data.result.organizationType // ประเภทองค์กร
          this.TypebusinessRegister = response.data.result.registerType === 'registerFull' ? 'ลงทะเบียนธุรกิจฉบับเต็ม' : 'ลงทะเบียนธุรกิจฉบับย่อ' // รูปแบบการลงทะเบียน(รอข้อมูล)
          this.taxDetailType = response.data.result.taxDetail === 'false' ? 'ไม่มีข้อมูลผู้เสียภาษี' : response.data.result.taxDetail === false ? 'ไม่มีข้อมูลผู้เสียภาษี' : 'มีข้อมูลผู้เสียภาษี'
          this.docsDetailType = response.data.result.docDetail === false ? 'ไม่มีหนังสือรับรอง' : 'มีหนังสือรับรอง' // เอกสารแนบ(รอข้อมูล)
          this.companyNameShortTh = response.data.result.companyShortNameTh
          this.companyNameShortEng = response.data.result.companyShortNameEng
          this.legalEntityTh = response.data.result.legalEntityTh // ประเภทนิติบุคคล
          this.otherTypeNames = response.data.result.otherTypeNames // ประเภทที่เพิ่มมาใหม่ T คือมีการเปลี่ยน F ไม่มีเปลี่ยน
          this.companyNameFullTh = response.data.result.companyFullNameTh
          this.nameUseInDocTh = response.data.result.nameUseInDocTh
          this.legalEntityEng = response.data.result.legalEntityEng
          this.companyNameFullEng = response.data.result.companyFullNameEng
          this.nameUseInDocEng = response.data.result.nameUseInDocEng
          this.taxId = response.data.result.taxId
          this.email = response.data.result.email
          this.region = response.data.result.region
          this.branchName = response.data.result.branchName
          this.branchCode = response.data.result.branchCode
          this.companyTelNo = response.data.result.companyTelNo
          this.companyMobilNumber = response.data.result.companyMobilNumber
          this.fax = response.data.result.fax
          this.companyAddressDetail.codeAddress = response.data.result.companyAddressDetail.codeAddress
          this.companyAddressDetail.address = response.data.result.companyAddressDetail.address
          this.companyAddressDetail.roomNo = response.data.result.companyAddressDetail.roomNo
          this.companyAddressDetail.floorNo = response.data.result.companyAddressDetail.floorNo
          this.companyAddressDetail.buildingName = response.data.result.companyAddressDetail.buildingName
          this.companyAddressDetail.villageName = response.data.result.companyAddressDetail.villageName
          this.companyAddressDetail.villageNo = response.data.result.companyAddressDetail.villageNo
          this.companyAddressDetail.alley = response.data.result.companyAddressDetail.alley
          this.companyAddressDetail.dispart = response.data.result.companyAddressDetail.dispart
          this.companyAddressDetail.road = response.data.result.companyAddressDetail.road
          this.companyAddressDetail.province = response.data.result.companyAddressDetail.province
          this.companyAddressDetail.district = response.data.result.companyAddressDetail.district
          this.companyAddressDetail.subDistrict = response.data.result.companyAddressDetail.subDistrict
          this.companyAddressDetail.postCode = response.data.result.companyAddressDetail.postCode
          this.filesCertificateId = response.data.result.companyCertificate
          this.filesCertificateName = response.data.result.companyCertificateName
          this.poaId = response.data.result.powerOfAttorney
          this.poaName = response.data.result.powerOfAttorneyName
          this.checkboxpoa = response.data.result.checkboxpoa
          this.commentUpdate = response.data.result.comment
          this.checkImageUrl = response.data.result.companyImage

          if (response.data.result.businessLevel !== '') {
            this.databussinessLevel = response.data.result.businessLevel
          } else {
            this.databussinessLevel = response.data.result.bussinessLevel
          }
          var imagesUrlCompany = response.data.result.companyImage
          this.axios({
            method: 'get',
            responseType: 'data',
            url: `${this.api}/api/vMonk/companys/getcompanyFileById/` + imagesUrlCompany
          }).then((response) => {
            this.imageUrl = `${this.api}/api/vMonk/companys/getcompanyFileById/` + imagesUrlCompany
          }).catch(e => {
            this.imageUrl = ''
            console.log(e)
          })
          const temp = []
          // response.data.result.userData.map((el, index) => {
          response.data.result.companyLeader.map((el, index) => {
            // el.companyImage = `${this.api}/api/vMonk/companys/getcompanyFileById/` + el.companyImage
            temp.push({
              approverNo: this.approver.length + 1,
              approverName: el.titleTh + el.firstNameTh + ' ' + el.lastNameTh,
              email: el.emailOneId,
              tel: el.tel,
              failed_image: false,
              ...el
            })
            this.userIdList.push({
              userId: el.employeeId,
              companyId: el.companyId
            })
            this.approver = temp
          })
          this.itemVersion = []
          response.data.result.version.map((el, index) => {
            this.itemVersion.push({
              no: el.versionNo,
              detail:
                  'เวอร์ชั่นที่ ' +
                  el.versionNo +
                  ' - ' +
                  this.initDate(el.updateAt),
              ...el
            })
          })
          this.versionDate =
              response.data.result.version.length !== 0
                ? response.data.result.version[0]._id
                : []
          this.versionDateOld = this.versionDate
          var pathFileName = 'uploads/companyFile/' + this.companyNameFullEng + '/'
          var substringsCertificate = response.data.result.companyCertificate.split(pathFileName, 2)
          var substringsPoa = response.data.result.powerOfAttorney.split(pathFileName, 2)
          this.filesPoa.push({
            name: substringsPoa[1]
          })
          this.filesCertificate.push({
            name: substringsCertificate[1]
          })
          this.loading = false
        }).catch(e => {
          swal('คำเตือน', 'คุณไม่มีสิทธิ์เข้าดูเอกสารนี้', 'warning', {
            button: false,
            timer: 2000
          })
          setTimeout(() => {
            this.goBack()
          }, 2000)
          console.log(e)
        })
      } else {
        await this.axios({
          method: 'POST',
          url: `${this.api}/api/vMonk/organization/newInfomation/` + this.getId,
          headers: {
            authorization: this.$store.state.token
          }
        }).then((response) => {
          if (response.data.new.businessModelType === 'market') {
            this.businessModelType = 'กิจการ'
          } else if (response.data.new.businessModelType === 'corporation') {
            this.businessModelType = 'นิติบุคคล'
          } else {
            this.businessModelType = 'องค์กร'
          }
          this.businessType = response.data.new.businessType // ประเภทกิจการ,ประเภทองค์กร,ประเภทนิติบุคค th
          this.businessTypeEng = response.data.new.businessTypeEn // ประเภทกิจการ,ประเภทองค์กร,ประเภทนิติบุคค eng
          this.businessModelTypeEng = response.data.new.businessModelType // รูปแบบธุรกิจอิ้ง
          this.TypebusinessRegister = response.data.new.registerType === 'registerFull' ? 'ลงทะเบียนธุรกิจฉบับเต็ม' : 'ลงทะเบียนธุรกิจฉบับย่อ' // รูปแบบการลงทะเบียน(รอข้อมูล)
          this.taxDetailType = response.data.new.taxDetail === 'false' ? 'ไม่มีข้อมูลผู้เสียภาษี' : response.data.new.taxDetail === false ? 'ไม่มีข้อมูลผู้เสียภาษี' : 'มีข้อมูลผู้เสียภาษี'
          this.docsDetailType = response.data.new.docDetail === false ? 'ไม่มีหนังสือรับรอง' : 'มีหนังสือรับรอง' // เอกสารแนบ(รอข้อมูล)
          this.companyNameShortTh = response.data.new.companyShortNameTh
          this.companyNameShortEng = response.data.new.companyShortNameEng
          this.otherTypeNames = response.data.new.otherTypeNames // ประเภทที่เพิ่มมาใหม่ T คือมีการเปลี่ยน F ไม่มีเปลี่ยน
          this.companyNameFullTh = response.data.new.companyFullNameTh
          this.nameUseInDocTh = response.data.new.nameUseInDocTh
          this.legalEntityEng = response.data.new.legalEntityEng
          this.companyNameFullEng = response.data.new.companyFullNameEng
          this.nameUseInDocEng = response.data.new.nameUseInDocEng
          this.taxId = response.data.new.taxId
          this.email = response.data.new.email
          this.region = response.data.new.region
          this.branchName = response.data.new.branchName
          this.branchCode = response.data.new.branchCode
          this.companyTelNo = response.data.new.companyTelNo
          this.companyMobilNumber = response.data.new.companyMobilNumber
          this.fax = response.data.new.fax
          this.companyAddressDetail.codeAddress = response.data.new.companyAddressDetail.codeAddress
          this.companyAddressDetail.address = response.data.new.companyAddressDetail.address
          this.companyAddressDetail.roomNo = response.data.new.companyAddressDetail.roomNo
          this.companyAddressDetail.floorNo = response.data.new.companyAddressDetail.floorNo
          this.companyAddressDetail.buildingName = response.data.new.companyAddressDetail.buildingName
          this.companyAddressDetail.villageName = response.data.new.companyAddressDetail.villageName
          this.companyAddressDetail.villageNo = response.data.new.companyAddressDetail.villageNo
          this.companyAddressDetail.alley = response.data.new.companyAddressDetail.alley
          this.companyAddressDetail.dispart = response.data.new.companyAddressDetail.dispart
          this.companyAddressDetail.road = response.data.new.companyAddressDetail.road
          this.companyAddressDetail.province = response.data.new.companyAddressDetail.province
          this.companyAddressDetail.district = response.data.new.companyAddressDetail.district
          this.companyAddressDetail.subDistrict = response.data.new.companyAddressDetail.subDistrict
          this.companyAddressDetail.postCode = response.data.new.companyAddressDetail.postCode
          this.filesCertificateId = response.data.new.companyCertificate
          this.filesCertificateName = response.data.new.companyCertificateName
          this.poaId = response.data.new.powerOfAttorney
          this.poaName = response.data.new.powerOfAttorneyName
          this.checkboxpoa = response.data.new.checkboxpoa
          this.commentUpdate = response.data.new.comment
          this.checkImageUrl = response.data.new.companyImage
          var imagesUrlCompany = response.data.new.companyImage
          if (imagesUrlCompany.length < 30) {
            this.axios({
              method: 'get',
              responseType: 'data',
              url: `${this.api}/api/vMonk/companys/getcompanyFileById/` + imagesUrlCompany
            }).then((response) => {
              this.imageUrl = `${this.api}/api/vMonk/companys/getcompanyFileById/` + imagesUrlCompany
            }).catch(e => {
              this.imageUrl = ''
              console.log(e)
            })
          } else {
            this.imageUrl = 'data:image/png;base64,' + imagesUrlCompany
          }
          if (response.data.new.businessLevel !== '') {
            this.databussinessLevel = response.data.new.businessLevel
          } else {
            this.databussinessLevel = response.data.new.bussinessLevel
          }
          const temp = []
          response.data.new.companyLeader.map((el, index) => {
            // el.companyImage = `${this.api}/api/vMonk/companys/getcompanyFileById/` + el.companyImage
            temp.push({
              approverNo: this.approver.length + 1,
              approverName: el.titleTh + el.firstNameTh + ' ' + el.lastNameTh,
              email: el.emailOneId,
              tel: el.tel,
              failed_image: false,
              ...el
            })
            this.userIdList.push({
              userId: el.employeeId,
              companyId: el.companyId
            })
            this.approver = temp
          })
        }).catch(e => {
          console.log(e)
        })
      }
    },
    openDialogAddAprover (action, item, index, type) {
      // console.log('add')
      EventBus.$emit('openDialogAddAprover', true, item, action, index, type)
    },
    add (value, index, action, type) {
      var today = new Date()
      var date = today.getDate() + '-' + (today.getMonth() + 1) + '-' + today.getFullYear()
      var filterValue = this.approver.filter(r => {
        if (r.position === value.position && r.employeeId === value.employeeId) {
          return r
        }
      })
      var filterValueTemporary = this.temporaryer.filter(r => {
        if (r.position === value.position && r.employeeId === value.employeeId) {
          return r
        }
      })
      if (type === 'approver') {
        if (action === 'add') {
          if (filterValue.length > 0) {
            swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
          } else {
            // console.log('No Dup', filterValue)
            this.approver.push({
              approverNo: this.approver.length + 1,
              _id: value.id,
              employeeId: value.employeeId,
              approverName: value.name,
              position: value.position,
              email: value.email,
              userImg: value.userImg,
              approveType: value.approveType,
              failed_image: false
            })
            this.userIdList.push({
              userId: value.id,
              companyId: value.companyId
            })
            // console.log('add approver:', this.approver)
            // console.log('add temporaryer:', this.temporaryer)
          }
        } else if (action === 'edit') {
          if (filterValue.length > 0) {
            swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
          } else {
            this.approver[index].approverNo = index + 1
            this.approver[index]._id = value.id
            this.approver[index].employeeId = value.employeeId
            this.approver[index].approverName = value.name
            this.approver[index].position = value.position
            this.approver[index].email = value.email
            this.approver[index].approveType = value.approveType
            this.approver[index].userImg = value.userImg
            this.approver[index].failed_image = value.failed_image || false
          }
        }
      } else if (type === 'temporaryer') {
        if (action === 'add') {
          if (filterValueTemporary.length > 0) {
            swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
          } else {
            this.temporaryer.push({
              approverNo: this.approver.length + 1,
              _id: value.id,
              employeeId: value.employeeId,
              approverName: value.name,
              position: value.position,
              email: value.email,
              userImg: value.userImg,
              approveType: value.approveType,
              failed_image: false
            })
            this.userIdListTemporary.push({
              userId: value.id,
              temporaryDate: date
            })
          }
        } else if (action === 'edit') {
          if (filterValueTemporary.length > 0) {
            swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
          } else {
            this.temporaryer[index].approverNo = index + 1
            this.temporaryer[index]._id = value.id
            this.temporaryer[index].employeeId = value.employeeId
            this.temporaryer[index].approverName = value.name
            this.temporaryer[index].position = value.position
            this.temporaryer[index].email = value.email
            this.temporaryer[index].approveType = value.approveType
            this.temporaryer[index].userImg = value.userImg
            this.temporaryer[index].failed_image = value.failed_image || false
          }
        }
      }
    },
    checkRemove (item, type) {
      this.itemConfirmDelete = []
      this.titleDialog = type
      this.itemConfirmDelete = item
      this.dialogDeleteApprover = true
    },
    removeApprover (item, type) {
      // console.log('removeApprover', this.approver.indexOf(item))
      if (type === 'approver') {
        this.approver.splice(this.approver.indexOf(item), 1)
        this.itemConfirmDelete = []
        this.itemIndex = 0
        this.dialogDeleteApprover = false
      } else if (type === 'temporaryer') {
        this.temporaryer.splice(this.temporaryer.indexOf(item), 1)
        this.itemConfirmDelete = []
        this.itemIndex = 0
        this.dialogDeleteApprover = false
      }
    },
    changeType (value) {
      if (value === 'new') {
        var businessTypeNameTh = ''
        var businessTypeNameEng = ''
        if (this.businessModelType === 'กิจการ') {
          businessTypeNameTh = this.businessType
          businessTypeNameEng = this.businessTypeEng
        } else if (this.businessModelType === 'นิติบุคคล') {
          businessTypeNameTh = this.businessType
          businessTypeNameEng = this.businessTypeEng
        } else {
          businessTypeNameTh = this.businessType
          businessTypeNameEng = this.businessTypeEng
        }
        var data = {
          businessTypeName: businessTypeNameTh,
          businessTypeNameEng: businessTypeNameEng,
          businessModelType: this.businessModelTypeEng,
          companyId: this.reqBusinessId,
          requestId: this.getId // ใบคำขอ
        }
        // console.log('ข้อมูลประเภทที่แก้ไขใหม่', data)
        this.axios({
          method: 'post',
          url: `${this.api}/api/vMonk/selector/businessType/approve`,
          data: {
            // businessTypeName: businessTypeNameTh,
            // businessTypeNameEng: businessTypeNameEng,
            businessModelType: this.businessModelTypeEng,
            companyId: this.reqBusinessId,
            requestId: this.getId // ใบคำขอ
          }
        }).then(response => {
          if (response.data.success) {
            // console.log(response)
            this.text = `คุณได้ทำการเพิ่มประเภท${this.businessModelType}เรียบร้อยแล้ว`
            this.snackbarColor = 'success'
            this.snackbar = true
            this.statusChangeTypeNew = true
            this.idOtherTypeNamesTh = response.data.newType._id
            this.idOtherTypeNamesEng = response.data.newType._id
            this.dialogConfirmTypeNewTh = false
          } else {
            swal('ผิดพลาด', response.data.msg, 'error')
          }
        }).catch(e => {
          console.log(e)
        })
      } else {
        var businessTypeNameOldTh = ''
        var nameTypeTh = ''
        var nameTypeEng = ''
        if (this.businessModelType === 'กิจการ') {
          businessTypeNameOldTh = this.businessNewTypeTh
          this.itemBusiness.forEach((element) => {
            if (businessTypeNameOldTh === element._id) {
              nameTypeTh = element.name
              nameTypeEng = element.nameEn
            }
          })
          this.nameTypeOldTh = nameTypeTh
          this.nameTypeOldEng = nameTypeEng
          this.idOtherTypeNamesTh = businessTypeNameOldTh
          // console.log('ประเภท', this.nameTypeOldTh, this.nameTypeOldEng)
          // console.log('id =', this.idOtherTypeNamesTh)
        } else if (this.businessModelType === 'นิติบุคคล') {
          businessTypeNameOldTh = this.businessNewTypeTh
          this.itemlegalEntity.forEach((element) => {
            if (businessTypeNameOldTh === element._id) {
              nameTypeTh = element.name
              nameTypeEng = element.nameEn
            }
          })
          this.nameTypeOldTh = nameTypeTh
          this.nameTypeOldEng = nameTypeEng
          this.idOtherTypeNamesTh = businessTypeNameOldTh
          // console.log('ประเภท', this.nameTypeOldTh, this.nameTypeOldEng)
          // console.log('id =', this.idOtherTypeNamesTh)
        } else {
          businessTypeNameOldTh = this.businessNewTypeTh
          this.itemOrganization.forEach((element) => {
            if (businessTypeNameOldTh === element._id) {
              nameTypeTh = element.name
              nameTypeEng = element.nameEn
            }
          })
          this.nameTypeOldTh = nameTypeTh
          this.nameTypeOldEng = nameTypeEng
          this.idOtherTypeNamesTh = businessTypeNameOldTh
          // console.log('ประเภท', this.nameTypeOldTh, this.nameTypeOldEng)
          // console.log('id =', this.idOtherTypeNamesTh)
        }
        this.text = `คุณได้ทำการเพิ่มประเภท${this.businessModelType}เรียบร้อยแล้ว`
        this.snackbarColor = 'success'
        this.snackbar = true
        this.statusChangeTypeNew = true
        this.statusChangeTypeOld = true
        this.dialogConfirmChangeTypeTh = false
        // this.dialogConfirmChangeTypeEng = false
        this.dialogConfirmTypeNewTh = false
        // this.dialogConfirmTypeNewEng = false
      }
    },
    async submitDataCreate () {
      this.userDataStore = this.$store.state.user
      var formData = new FormData()
      formData.append('groupCompanyId', this.groupName)
      formData.append('companyFullNameEng', this.companyNameFullEng)
      formData.append('companyFullNameTh', this.companyNameFullTh)
      formData.append('companyShortNameTh', this.companyNameShortTh)
      formData.append('companyShortNameEng', this.companyNameShortEng)
      formData.append('legalEntityTh', this.legalEntityTh)
      formData.append('legalEntityEng', this.legalEntityEng)
      formData.append('nameUseInDocTh', this.nameUseInDocTh)
      formData.append('nameUseInDocEng', this.nameUseInDocEng)
      formData.append('taxId', this.taxId)
      formData.append('email', this.email)
      formData.append('branchName', this.branchName)
      formData.append('branchCode', this.branchCode)
      formData.append('companyTelNo', this.companyTelNo)
      formData.append('companyMobilNumber', this.companyMobilNumber)
      formData.append('fax', this.fax)
      formData.append('companyAddressDetail', JSON.stringify(this.companyAddressDetail))
      // formData.append('companyLeader', JSON.stringify(this.userIdList))
      formData.append('region', this.region)
      formData.append('temporaryLeaderCompany', JSON.stringify(this.userIdListTemporary))
      formData.append('titleTh', this.userDataStore.titleTh)
      formData.append('titleEn', '.')
      formData.append('firstNameTh', this.userDataStore.firstNameTh)
      formData.append('lastNameTh', this.userDataStore.lastNameTh)
      formData.append('firstNameEn', '')
      formData.append('lastNameEn', '')
      formData.append('accountId', '')
      formData.append('birthday', '')
      formData.append('emailUser', this.userDataStore.email)
      formData.append('emailOneId', this.userDataStore.emailOneId)
      formData.append('tel', '')
      formData.append('usernameOneId', '')
      // const obj = formData
      const obj = {
        groupCompanyId: this.groupName,
        companyFullNameEng: this.companyNameFullEng,
        companyFullNameTh: this.companyNameFullTh,
        companyShortNameTh: this.companyNameShortTh,
        companyShortNameEng: this.companyNameShortEng,
        legalEntityTh: this.legalEntityTh,
        legalEntityEng: this.legalEntityEng,
        nameUseInDocTh: this.nameUseInDocTh,
        nameUseInDocEng: this.nameUseInDocEng,
        taxId: this.taxId,
        email: this.email,
        branchName: this.branchName,
        branchCode: this.branchCode,
        companyTelNo: this.companyTelNo,
        companyMobilNumber: this.companyMobilNumber,
        fax: this.fax,
        companyAddressDetail: this.companyAddressDetail,
        region: this.region,
        temporaryLeaderCompany: JSON.stringify(this.userIdListTemporary),
        titleTh: this.userDataStore.titleTh,
        titleEn: '',
        firstNameTh: this.userDataStore.firstNameTh,
        lastNameTh: this.userDataStore.lastNameTh,
        firstNameEn: '',
        lastNameEn: '',
        accountId: '',
        birthday: '',
        emailUser: this.userDataStore.email,
        emailOneId: this.userDataStore.emailOneId,
        tel: '',
        usernameOneId: ''
      }
      // console.log('obj', obj)
      try {
        const res = await insertApproveCompany(obj, this.$store.state.token)
        if (res.success) {
          this.text = 'คุณได้ทำการเพิ่มบริษัทเรียบร้อยแล้ว'
          this.snackbarColor = 'success'
          this.snackbar = true
          // this.$router.go(-1)
          this.$router.push('/manageapprovecompany')
          // console.log('true')
        } else {
          swal('ผิดพลาด', res.data.msg, 'error')
          // this.loading = false
        }
      } catch (error) {
        console.log(error)
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
        // this.loading = false
      } finally {
        // this.loadingEmployeeData = false
      }
    },
    async updateStatusApprove (type) {
      if (type === 'อนุมัติ') {
        if (this.getReliable === false) {
          this.businessLevel = '0'
        }
        if (this.otherTypeNames === true && this.statusChangeTypeNew === true) { // กรณีมีการแก้ไขประเภท
          await axios({
            url: ` ${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/organizeApprove/approve`,
            method: 'POST',
            headers: {
              authorization: this.$store.state.token
            },
            data: {
              id: this.getId, // _id ใบคำขอ
              businessLevel: this.businessLevel,
              comment: this.comment,
              businessType: this.idOtherTypeNamesTh
            }
          })
            .then((response) => {
              if (response.data.success === true) {
                swal('สำเร็จ', 'ทำรายการสำเร็จเรียบร้อย', 'success', {
                  button: false,
                  timer: 2000
                })
                // this.dialog = false
                // this.text = 'คุณได้ทำการอนุมัติธุรกิจเรียบร้อยแล้ว!!!'
                // this.snackbar = true
                // this.snackbarColor = 'success'
                this.page = 1
                this.dialogApproverCompany = false
                this.$router.push('/manageapprovebusiness')
                // self.searchFilterData(self.filterData)
              } else {
                // this.text = 'คุณได้ทำการไม่อนุมัติธุรกิจเรียบร้อยแล้ว'
                // this.snackbar = true
                // this.snackbarColor = 'red'
                // this.dialogApproverCompany = false
                swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
                  button: false,
                  timer: 2000
                })
              }
            })
            .catch(function (thrown) {
              swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
                button: false,
                timer: 2000
              })
            })
        } else { // ไม่มีการแก้ไขประเภท
          await axios({
            url: ` ${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/organizeApprove/approve`,
            method: 'POST',
            headers: {
              authorization: this.$store.state.token
            },
            data: {
              id: this.getId, // _id ใบคำขอ
              businessLevel: this.businessLevel,
              comment: this.comment
            }
          })
            .then((response) => {
              if (response.data.success === true) {
                swal('สำเร็จ', 'ทำรายการสำเร็จเรียบร้อย', 'success', {
                  button: false,
                  timer: 2000
                })
                // this.dialog = false
                // this.text = 'คุณได้ทำการอนุมัติธุรกิจเรียบร้อยแล้ว!!!'
                // this.snackbar = true
                // this.snackbarColor = 'success'
                this.page = 1
                this.dialogApproverCompany = false
                this.$router.push('/manageapprovebusiness')
                // self.searchFilterData(self.filterData)
              } else {
                // this.text = 'คุณได้ทำการไม่อนุมัติธุรกิจเรียบร้อยแล้ว'
                // this.snackbar = true
                // this.snackbarColor = 'red'
                // this.dialogApproverCompany = false
                swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
                  button: false,
                  timer: 2000
                })
              }
            })
            .catch(function (thrown) {
              swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
                button: false,
                timer: 2000
              })
            })
        }
      } else {
        await axios({
          url: ` ${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/organizeApprove/denied`,
          method: 'POST',
          headers: {
            authorization: this.$store.state.token
          },
          data: {
          // approveList: confirmList
            id: this.getId, // _id ใบคำขอ
            status: type === 'ไม่อนุมัติ' ? 'denied' : 'cancel',
            // role: this.approveRole,
            // businessLevel: this.businessLevel,
            comment: this.comment
          }
        })
          .then((response) => {
            if (response.data.success === true) {
              swal('สำเร็จ', 'ทำรายการสำเร็จเรียบร้อย', 'success', {
                button: false,
                timer: 2000
              })
              // this.dialog = false
              // this.text = 'คุณได้ทำการอนุมัติธุรกิจเรียบร้อยแล้ว!!!'
              // this.snackbar = true
              // this.snackbarColor = 'success'
              this.page = 1
              this.dialogApproverCompany = false
              this.$router.push('/manageapprovebusiness')
            // self.searchFilterData(self.filterData)
            } else {
            // this.text = 'คุณได้ทำการไม่อนุมัติธุรกิจเรียบร้อยแล้ว'
            // this.snackbar = true
            // this.snackbarColor = 'red'
            // this.dialogApproverCompany = false
              swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
                button: false,
                timer: 2000
              })
            }
          })
          .catch(function (thrown) {
            swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
              button: false,
              timer: 2000
            })
          })
      }
    },
    addFiles (type) {
      // console.log('add type', type)
      if (type === 'certificate') {
        this.$refs.PickfilesCertificate.click()
        // console.log('add files', this.$refs.PickfilesCertificate)
      } else if (type === 'poa') {
        this.$refs.PickfilesPoa.click()
      }
    },
    onFileSelected (type) {
      if (type === 'certificate') {
        this.filesCertificate = []
        // console.log('On Certifycate')
        var uploadedFilesCertificate = this.$refs.PickfilesCertificate.files
        for (let i = 0; i < uploadedFilesCertificate.length; i++) {
          var dotindexCertificate = uploadedFilesCertificate[i].name.lastIndexOf('.')
          var FileExtension = uploadedFilesCertificate[i].name.substr(dotindexCertificate + 1).toLowerCase()

          if (FileExtension === 'pdf') {
            // console.log(uploadedFiles[i].name, 'ok')
            this.filesCertificate.push(uploadedFilesCertificate[i])
          } else {
            swal('คำเตือน', `ไม่รองรับไฟล์${uploadedFilesCertificate[i].name.substr(-4)}`, 'warning')
          }
        }
      } else if (type === 'poa') {
        this.filesPoa = []
        var uploadedFilesPoa = this.$refs.PickfilesPoa.files
        for (let i = 0; i < uploadedFilesPoa.length; i++) {
          var dotindexPoa = uploadedFilesPoa[i].name.lastIndexOf('.')
          var FileExtensionPoa = uploadedFilesPoa[i].name.substr(dotindexPoa + 1).toLowerCase()

          if (FileExtensionPoa === 'pdf') {
            this.filesPoa.push(uploadedFilesPoa[i])
          } else {
            swal('คำเตือน', `ไม่รองรับไฟล์${uploadedFilesPoa[i].name.substr(-4)}`, 'warning')
          }
        }
      }
    },
    removeFile (key, type) {
      if (type === 'certificate') {
        this.filesCertificate.splice(key, 1)
        const input = this.$refs.PickfilesCertificate
        input.type = 'text'
        input.type = 'file'
      } else if (type === 'poa') {
        this.filesPoa.splice(key, 1)
        const input = this.$refs.PickfilesPoa
        input.type = 'text'
        input.type = 'file'
      }
      // // console.log('remove key', key)
      // console.log('FILE ', this.files)
    },
    ChooseBanner () {
      this.$refs.Pickfiles.click()
    },
    onBannerSelected () {
      this.files = []
      var uploadedImage = this.$refs.Pickfiles.files
      var dotindex = uploadedImage[0].name.lastIndexOf('.')
      var FileExtension = uploadedImage[0].name.substr(dotindex + 1).toLowerCase()
      if (FileExtension === 'jpg' || FileExtension === 'png' || FileExtension === 'JPG' || FileExtension === 'PNG') {
        if (!uploadedImage[0]) return
        const reader = new FileReader()
        reader.readAsDataURL(uploadedImage[0])
        reader.onload = evt => {
          var img = new Image()
          this.files.push(uploadedImage[0])
          // console.log(this.files[0])
          const fr = new FileReader()
          fr.readAsDataURL(this.files[0])
          fr.addEventListener('load', () => {
            this.nameimg = this.files[0].name
            this.imageUrl = fr.result
          })
          img.src = evt.target.result
        }
        // reader.onerror = evt => {
        //   console.error(evt)
        // }
      } else {
        swal('คำเตือน', `ไม่รองรับไฟล์${uploadedImage[0].name.substr(-4)}`, 'warning')
      }
    },
    copyData () {
      // this.$router.push('managebusines/create')
      // this.reqBusinessId = this.versionDate
      this.$router.push({
        name: 'manageBusinescreate',
        params: {
          type: 'copyApproveBusiness',
          id: this.reqBusinessId
        }
      })
    }
  }
}
</script>
<style scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 5px;
  color: #757575;
}
span.txt-font-type {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #C0392B !important;
}
.txt-font-value {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #333333;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.base-image-input {
  /* display: block; */
  width: 34vh;
  height: 34vh;
  /* padding: 8%; */
  border-radius: 16px;
  cursor: unset;
  background-size: contain !important;
  background-repeat: no-repeat !important;
  background-position: center center !important;
  background: #F8F9FA;
}
/* src\assets\logo.png */
/* '@/assets/icons/no_user.png' */
/* src\assets\icons\no_user.png */
.placeholder-image {
  /* background: #F0F0F0; */
  background-image: url('../../../assets/icons/insert_photo.png');
  width: 100%;
  height: 100%;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat !important;
  background-position: center center !important;
  color: #333;
  font-size: 18px;
  font-family: 'Sarabun', sans-serif;
}
.placeholder:hover {
  /* background: #E0E0E0; */
  background-image: url('../../../assets/icons/no-company-7.png');

}
.file-input {
  display: none;
}
.box-image1 {
  border: 1px solid rgba(0, 0, 0, 0.4);
  outline: none;
  color: rgb(118, 118, 118);
  /* display: flex; */
  align-content: center;
  justify-content: center;
  display: grid;
  height: 70%;
  text-align: center;
}
.box-image2 {
  border: dashed;
  border-width: 1px 1px;
  border-radius: 10px;
}
.button {
  border: none;
  color: white;
  /* padding: 15px 32px; */
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}
.box-image3 {
  border-width: 1px 1px;
  border-radius: 5px;
  border: 2px solid #e7e7e7;
  height: 40px;

}
label {
  background-color: indigo;
  color: white;
  /* padding: 0.5rem; */
  padding: 0.7rem;
  font-family: sans-serif;
  border-radius: 0.3rem;
  cursor: pointer;
  margin-top: 1rem;
}
/* upfile pdf */
div.file-listing{
  width: 800px;
}
input[type="file"]{
  position: absolute;
  top: -500px;
  display:none;
}

  /* อัปโหลดไฟล์ */
  .upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn_click {
  border: 2px solid gray;
  /* color: gray; */
  background-color: white;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}

.upload-btn-wrapper input[type=file] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.ra-head-text-bold {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  color: #1654C6;
}
.ra-head-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
}
.ra-span-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #757575;
}
.radio-border {
  height: 45px;
  border: 2px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}
span.txt-head {
  color: black;
  font-size: 14px;
}
.v-menu__content--fixed {
    position: fixed;
    box-shadow: none !important;
}
</style>
